<template>
  <div class="shares_Info">
    <div class="box1">
      <div class="box1_left">
        <div class="box1_left_top">
          <div class="box1_left_top_text1">{{information.name}}</div>
          <div class="box1_left_top_text2">{{information.codes}}</div>
          <div class="box1_left_top_text3">有色金属</div>
          <div class="box1_left_top_text4">证券11</div>
          <div class="box1_left_top_text5">
            （{{information.tradeDate}}  {{information.tradeTime}}） 交易状态:交易中
          </div>
        </div>
        <div class="box1_left_bottom">
          <div class="box1_left_bottom_left">
            <div class="box1_left_bottom_left_text1">{{information.latest}}</div>
            <div class="box1_left_bottom_left_text2"><i :class="{'colorGreen':information.change<0,'colorRed':information.change>0}">{{information.change}}</i> <i :class="{'colorGreen':information.changeRatio<0,'colorRed':information.changeRatio>0}">{{information.changeRatio}}%</i></div>
          </div>
          <div class="box1_left_bottom_right">
            <div class="box1_left_bottom_right_group1">
              <div class="box1_left_bottom_right_text1">
                最高：<i style="font-style: normal; color: #fd4c4c">{{information.high}}</i>
              </div>
              <div class="box1_left_bottom_right_text1">
                最低：<i style="font-style: normal; color: #47ba74">{{information.low}}</i>
              </div>
            </div>
            <div class="box1_left_bottom_right_group1">
              <div class="box1_left_bottom_right_text1">
                今开：<i style="font-style: normal; color: #fd4c4c">{{information.open}}</i>
              </div>
              <div class="box1_left_bottom_right_text1">昨收：{{information.preClose}}</div>
            </div>
            <div class="box1_left_bottom_right_group1">
              <div class="box1_left_bottom_right_text1">成交量：{{information.volume}}</div>
              <div class="box1_left_bottom_right_text1">成交额：{{information.amount}}</div>
            </div>
            <div class="box1_left_bottom_right_group1">
              <div class="box1_left_bottom_right_text1">换手率：{{information.turnoverRatio}}</div>
              <div class="box1_left_bottom_right_text1">振幅：{{information.swing}}</div>
            </div>
            <div class="box1_left_bottom_right_group1">
              <div class="box1_left_bottom_right_text1">市盈(静)：{{information.pbr_lf}}</div>
              <div class="box1_left_bottom_right_text1">市盈(TTM)：{{information.pe_ttm}}</div>
            </div>
            <div class="box1_left_bottom_right_group1">
              <div class="box1_left_bottom_right_text1">每股收益：</div>
              <div class="box1_left_bottom_right_text1">每股净资产：</div>
            </div>
            <div class="box1_left_bottom_right_group1">
              <div class="box1_left_bottom_right_text1">流通股本：</div>
              <div class="box1_left_bottom_right_text1">
                流通市值：{{information.mv}}
              </div>
            </div>
            <div class="box1_left_bottom_right_group1">
              <div class="box1_left_bottom_right_text1">总市值：{{information.totalCapital}}</div>
              <div class="box1_left_bottom_right_text1">市净值：{{information.pb}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="box1_right">
        <div class="box1_right_top">
          <img
            style="
              width: 12px;
              height: 12px;
              vertical-align: middle;
              margin-right: 2px;
            "
            src="../../../public/img/shares_Info/add.png"
            alt=""
          />
          添加自选
        </div>
        <div class="box1_right_bottom">
          <div class="box1_right_bottom_left">
            <img
              style="
                width: 14px;
                height: 14px;
                vertical-align: middle;
                margin-right: 2px;
              "
              src="../../../public/img/shares_Info/contrast.png"
              alt=""
            />股票对比
          </div>
          <div class="box1_right_bottom_right" @click="frame1_open">
            公司简介
          </div>
        </div>
      </div>
    </div>
    <div class="box2">
      <div class="box2_top_button">
        <div
          class="box2_top_button_text1"
          :class="{ box2_top_button_text2: change_option == 0 }"
          @click="change_change_option(0)"
        >
          日k
        </div>
        <div
          class="box2_top_button_text1"
          :class="{ box2_top_button_text2: change_option == 1 }"
          @click="change_change_option(1)"
        >
          周k
        </div>
        <div
          class="box2_top_button_text1"
          :class="{ box2_top_button_text2: change_option == 2 }"
          @click="change_change_option(2)"
        >
          月k
        </div>
        <div
          class="box2_top_button_text1"
          :class="{ box2_top_button_text2: change_option == 3 }"
          @click="change_change_option(3)"
        >
          年k
        </div>
      </div>
      <Chart1></Chart1>
    </div>
    <div class="box3">
      <div class="box3_top">
        <div class="box3_text1">
          利好因素(2条)
          <img src="../../../public/img/shares_Info/vip.png" alt="" />
        </div>
        <div class="box3_text2" @click="box3_show = true">
          点击展开
          <img src="../../../public/img/shares_Info/xiala_bottom.png" alt="" />
        </div>
      </div>
      <div class="box3_content" v-if="box3_show">
        <div class="box3_content_options1">
          <div class="box3_content_options1_text1">利润</div>
          <div class="box3_content_options1_text2">
            最新季度，归母净利润同比增长<i class="i1">348%</i>，利润成长性强。
          </div>
        </div>
        <div class="box3_content_options1 margin_top18">
          <div class="box3_content_options1_text1">PEG</div>
          <div class="box3_content_options1_text2">
            未来3年，机构预测净利润每年增长 <i class="i1">77%</i> ，PEG为
            <i class="i1">0.25</i> ，价值或被低估。
          </div>
        </div>
        <div class="box3_content_options1 margin_top18">
          <div class="box3_content_options1_text1">回购</div>
          <div class="box3_content_options1_text2">
            近1月，公司累计回购 <i class="i1">51.3万股</i>，占总股本比例
            <i class="i1">0.22%</i> ，金额合计 <i class="i1">2260万元</i>
          </div>
        </div>
      </div>
    </div>

    <div class="box4">
      <div class="box4_top">
        <div class="box4_text1">
          利空因素(2条)
          <img src="../../../public/img/shares_Info/vip.png" alt="" />
        </div>
        <div class="box4_text2" @click="box4_show = true">
          点击展开
          <img src="../../../public/img/shares_Info/xiala_bottom.png" alt="" />
        </div>
      </div>
      <div class="box4_content" v-if="box4_show">
        <div class="box4_content_options1">
          <div class="box4_content_options1_text1">利润</div>
          <div class="box4_content_options1_text2">
            最新季度，归母净利润同比增长<i class="i1">348%</i>，利润成长性强。
          </div>
        </div>
        <div class="box4_content_options1 margin_top18">
          <div class="box4_content_options1_text1">PEG</div>
          <div class="box4_content_options1_text2">
            未来3年，机构预测净利润每年增长 <i class="i1">77%</i> ，PEG为
            <i class="i1">0.25</i> ，价值或被低估。
          </div>
        </div>
        <div class="box4_content_options1 margin_top18">
          <div class="box4_content_options1_text1">回购</div>
          <div class="box4_content_options1_text2">
            近1月，公司累计回购 <i class="i1">51.3万股</i>，占总股本比例
            <i class="i1">0.22%</i> ，金额合计 <i class="i1">2260万元</i>
          </div>
        </div>
      </div>
    </div>

    <div class="box5">
      <div class="box5_top_title">大事提醒</div>
      <div class="box5_top_button">
        <div
          class="box5_top_button_button1"
          :class="{ box5_top_button_button2: bxjj_navigation == 0 }"
          @click="change_top_button(0)"
        >
          沪深
        </div>
        <div
          class="box5_top_button_button1"
          :class="{ box5_top_button_button2: bxjj_navigation == 1 }"
          @click="change_top_button(1)"
        >
          一级行业
        </div>
        <div
          class="box5_top_button_button1"
          :class="{ box5_top_button_button2: bxjj_navigation == 2 }"
          @click="change_top_button(2)"
        >
          二级行业
        </div>
        <div
          class="box5_top_button_button1"
          :class="{ box5_top_button_button2: bxjj_navigation == 3 }"
          @click="change_top_button(3)"
        >
          三级行业
        </div>
      </div>
      <div class="box5_table">
        <div v-if="bxjj_navigation == 0">
          <el-table
            :data="tableData"
            border
            style="width: 100%"
            header-row-class-name="back_hui"
          >
            <el-table-column
              prop="date"
              label="日期"
              width="180"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="name" label="公告内容">
              <template slot-scope="scope">
                <div class="box5_table_centent_text1">
                  瑞联新材：2021年三季度报
                </div>
                <div class="box5_table_centent_text2">
                  净利润累计同比
                  <i style="font-style: normal; color: #fd4c4c">{{
                    scope.row.data1
                  }}</i
                  >，单季同比
                  <i style="font-style: normal; color: #fd4c4c">{{
                    scope.row.data2
                  }}</i
                  >。营业收入累计同比
                  <i style="font-style: normal; color: #fd4c4c">{{
                    scope.row.data3
                  }}</i
                  >，单季同比
                  <i style="font-style: normal; color: #fd4c4c">{{
                    scope.row.data4
                  }}</i>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="操作" width="180">
              <template slot-scope="scope">
                <div @click="ckqw(scope.row)" class="box5_table_cz">
                  查看全文
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else style="text-align: center; height: 273px">
          <img
            src="../../../public/img/shares_Info/null.png"
            alt=""
            style="vertical-align: middle; width: 223px; margin-top: 50px"
          />
          <div
            style="
              height: 15px;
              font-size: 14px;
              line-height: 15px;
              color: #999999;
              margin-top: 15px;
            "
          >
            暂无数据
          </div>
        </div>
      </div>
      <div class="box5_bottom" v-if="bxjj_navigation == 0">
        <div style="margin: 0 auto; width: 90px; cursor: pointer">
          展开更多
          <img src="../../../public/img/shares_Info/xiala_bottom.png" alt="" />
        </div>
      </div>
    </div>
    <div class="box6">
      <div class="box6_top_title">
        估值与分位
        <div class="box20_top_title_text3">
          <img
            style="width: 15px; vertical-align: middle; margin-left: 3px"
            src="../../../public/img/shares_Info/yiwen_yellow.png"
            alt=""
            @click="frame2_open"
          />
        </div>
        <div class="box7_top_title_text2"> <div @click="chart2_option_open"><i v-if="chart2_option==3">最近10年</i><i v-if="chart2_option==1">最近3年</i><i v-if="chart2_option==2">最近5年</i><img style="width: 9px; vertical-align: middle; margin-left: 3px" src="../../../public/img/shares_Info/xiala_bottom_yellow.png"/></div>
          <div class="box7_top_title_option" v-if="chart2_option_show">
            <div @click="changeoption(1)">最近3年</div>
            <div @click="changeoption(2)">最近5年</div>
            <div @click="changeoption(3)">最近10年</div>
          </div>
        </div>
      </div>
      <div class="box6_top_button">
        <div
          class="box6_top_button_button1"
          :class="{ box6_top_button_button2: bxjj_navigation2 == 0 }"
          @click="change_top_button2(0)"
        >
          市盈率({{chart2_data_1}})
        </div>
        <div
          class="box6_top_button_button1"
          :class="{ box6_top_button_button2: bxjj_navigation2 == 1 }"
          @click="change_top_button2(1)"
        >
          市净率({{chart2_data_2}})
        </div>
        <div
          class="box6_top_button_button1"
          :class="{ box6_top_button_button2: bxjj_navigation2 == 2 }"
          @click="change_top_button2(2)"
        >
          市销率({{chart2_data_3}})
        </div>
        <div
          class="box6_top_button_button1"
          :class="{ box6_top_button_button2: bxjj_navigation2 == 3 }"
          @click="change_top_button2(3)"
        >
          市现率({{chart2_data_4}})
        </div>
        <div
          class="box6_top_button_button1"
          :class="{ box6_top_button_button2: bxjj_navigation2 == 4 }"
          @click="change_top_button2(4)"
        >
          企业倍数(--)
        </div>
      </div>
      <div v-if="chart2_data_x.length > 0">
        <div class="box6_top_tip">
          {{chart2_data_txt}}
        </div>
        <div class="box6_top_legend_box">
          <div class="box6_top_legend_box_option1">
            <div class="box6_top_legend_box_option1_colordiv"></div>
            高估线
          </div>
          <div class="box6_top_legend_box_option1">
            <div class="box6_top_legend_box_option2_colordiv"></div>
            中估线
          </div>
          <div class="box6_top_legend_box_option1">
            <div class="box6_top_legend_box_option3_colordiv"></div>
            低估线
          </div>
        </div>
        <Chart2 ref="chart2" :chart2_data_x='chart2_data_x' :chart2_data_y='chart2_data_y' :chart2_data_y2='chart2_data_y2' :chart2_data_y3='chart2_data_y3' :chart2_data_y4='chart2_data_y4'></Chart2>
      </div>
      <div v-else style="text-align: center; height: 350px">
        <img
          src="../../../public/img/shares_Info/null.png"
          alt=""
          style="vertical-align: middle; width: 223px; margin-top: 90px"
        />
        <div
          style="
            height: 15px;
            font-size: 14px;
            line-height: 15px;
            color: #999999;
            margin-top: 15px;
          "
        >
          公司上市不满一年，暂不提供估值分位
        </div>
      </div>
    </div>
    <div class="box7">
      <div class="box7_top_title">
        <div class="box7_top_title_text1">PE/PB Band</div>
        <div class="box7_top_title_text2">
          最近10年<img
            style="width: 9px; vertical-align: middle; margin-left: 3px"
            src="../../../public/img/shares_Info/xiala_bottom_yellow.png"
            alt=""
          />
        </div>
      </div>
      <div class="box7_top_button">
        <div
          class="box7_top_button_button1"
          :class="{ box7_top_button_button2: bxjj_navigation3 == 0 }"
          @click="change_top_button3(0)"
        >
          市盈率(28.7)
        </div>
        <div
          class="box7_top_button_button1"
          :class="{ box7_top_button_button2: bxjj_navigation3 == 1 }"
          @click="change_top_button3(1)"
        >
          市净率(2.27)
        </div>
        <div
          class="box7_top_button_button1"
          :class="{ box7_top_button_button2: bxjj_navigation3 == 2 }"
          @click="change_top_button3(2)"
        >
          市销率(4.34)
        </div>
        <div
          class="box7_top_button_button1"
          :class="{ box7_top_button_button2: bxjj_navigation3 == 3 }"
          @click="change_top_button3(3)"
        >
          市现率(28.1)
        </div>
      </div>
      <div class="box7_top_tip">
        历史：高于近十年54.20%的时间。 行业：高于消费电子行业均值(26.66)。
        若考虑业绩预告，市盈率为负数，本估值法不适用。
      </div>
      <div class="box7_top_legend_box">
        <div class="box7_top_legend_box_option1">
          <div class="box7_top_legend_box_option1_colordiv"></div>
          股价
        </div>
        <div class="box7_top_legend_box_option1">
          <div class="box7_top_legend_box_option2_colordiv"></div>
          61.6X
        </div>
        <div class="box7_top_legend_box_option1">
          <div class="box7_top_legend_box_option3_colordiv"></div>
          53.2X
        </div>
        <div class="box7_top_legend_box_option1">
          <div class="box7_top_legend_box_option4_colordiv"></div>
          53.2X
        </div>
        <div class="box7_top_legend_box_option1">
          <div class="box7_top_legend_box_option5_colordiv"></div>
          53.2X
        </div>
        <div class="box7_top_legend_box_option1">
          <div class="box7_top_legend_box_option6_colordiv"></div>
          27.8X
        </div>
      </div>
      <Chart3 ref="chart3" :chart3_data_x='chart3_data_x' :chart3_data_y='chart3_data_y' :chart3_data_y2='chart3_data_y2' :chart3_data_y3='chart3_data_y3' :chart3_data_y4='chart3_data_y4' :chart3_data_y5='chart3_data_y5' :chart3_data_y6='chart3_data_y6' :chart3_data_data='chart3_data_data'></Chart3>
    </div>

    <div class="box8">
      <div class="box8_top_title">
        <div class="box8_top_title_text1">成长能力</div>
        <div class="box20_top_title_text3">
          <img
            style="width: 15px; vertical-align: middle; margin-left: 3px"
            src="../../../public/img/shares_Info/yiwen_yellow.png"
            alt=""
            @click="frame10_open"
          />
        </div>
        <div class="box8_top_title_text2"><div @click="chart4_option_open"><i v-if="chart4_option == 1">按季度</i><i v-if="chart4_option == 2">按年度</i><img style="width: 9px; vertical-align: middle; margin-left: 3px" src="../../../public/img/shares_Info/xiala_bottom_yellow.png"/></div>
        <div class="box8_top_title_option" v-if="chart4_option_show">
          <div @click="changeoption4(1)">按季度</div>
          <div @click="changeoption4(2)">按年度</div>
        </div>
        </div>
      </div>
      <div class="box8_top_button">
        <div
          class="box8_top_button_button1"
          :class="{ box8_top_button_button2: bxjj_navigation4 == 0 }"
          @click="change_top_button4(0)"
        >
          营收总收入({{chart4_data_1}})
        </div>
        <div
          class="box8_top_button_button1"
          :class="{ box8_top_button_button2: bxjj_navigation4 == 1 }"
          @click="change_top_button4(1)"
        >
          归母净利润({{chart4_data_2}})
        </div>
        <div
          class="box8_top_button_button1"
          :class="{ box8_top_button_button2: bxjj_navigation4 == 2 }"
          @click="change_top_button4(2)"
        >
          扣非净利润({{chart4_data_3}})
        </div>
      </div>
      <div class="box8_top_legend_box" v-if="chart4_option == 1">
        <div class="box8_top_legend_box_option1">
          <div class="box8_top_legend_box_option1_colordiv"></div>
          一季度
        </div>
        <div class="box8_top_legend_box_option1">
          <div class="box8_top_legend_box_option2_colordiv"></div>
          二季度
        </div>
        <div class="box8_top_legend_box_option1">
          <div class="box8_top_legend_box_option3_colordiv"></div>
          三季度
        </div>
        <div class="box8_top_legend_box_option1">
          <div class="box8_top_legend_box_option4_colordiv"></div>
          四季度
        </div>
      </div>
      <div class="box8_top_legend_box" v-else>
        <div class="box8_top_legend_box_option1">
          <div class="box8_top_legend_box_option4_colordiv"></div>
          归母净利润
        </div>
        <div class="box8_top_legend_box_option1">
          <div class="box8_top_legend_box_option5_colordiv"></div>
          同比增长率
        </div>
      </div>
      <Chart4 v-if="chart4_option == 1" ref="chart4" :chart4_data_x='chart4_data_x' :chart4_data_y='chart4_data_y' :chart4_data_y2='chart4_data_y2' :chart4_data_y3='chart4_data_y3' :chart4_data_y4='chart4_data_y4' :chart4_data_table='chart4_data_table'></Chart4>
      <Chart42 v-else ref="chart42" :chart42_data_x='chart42_data_x' :chart42_data_y='chart42_data_y' :chart42_data_y2='chart42_data_y2' :chart42_data_table='chart42_data_table'></Chart42>
    </div>
    <div class="box9">
      <div class="box9_top_title">
        <div class="box9_top_title_text1">盈利能力-杜邦分析</div>
        <div class="box9_top_title_text2">
          切换对比<img
            style="width: 9px; vertical-align: middle; margin-left: 3px"
            src="../../../public/img/shares_Info/qiehuan.png"
            alt=""
          />
        </div>
      </div>
      <div class="box9_top_legend_box">
        <div class="box9_top_legend_box_option1">
          <div class="box9_top_legend_box_option1_colordiv"></div>
          格力电器
        </div>
        <div class="box9_top_legend_box_option1">
          <div class="box9_top_legend_box_option2_colordiv"></div>
          白色家电
        </div>
      </div>
      <Chart5 ref="chart5" :chart5_data_y='chart5_data_y' :chart5_data_y2='chart5_data_y2'></Chart5>
    </div>

    <div class="box10">
      <div class="box10_top_title">
        <div class="box10_top_title_text1">盈利能力-回报率</div>
        <div class="box20_top_title_text3">
          <img
            style="width: 15px; vertical-align: middle; margin-left: 3px"
            src="../../../public/img/shares_Info/yiwen_yellow.png"
            alt=""
            @click="frame11_open"
          />
        </div>
        <div class="box10_top_title_text2">
          切换对比<img
            style="width: 9px; vertical-align: middle; margin-left: 3px"
            src="../../../public/img/shares_Info/qiehuan.png"
            alt=""
          />
        </div>
      </div>
      <div class="box10_top_button">
        <div
          class="box10_top_button_button1"
          :class="{ box10_top_button_button2: bxjj_navigation5 == 0 }"
          @click="change_top_button5(0)"
        >
          ROE({{chart6_data_1}}%)
        </div>
        <div
          class="box10_top_button_button1"
          :class="{ box10_top_button_button2: bxjj_navigation5 == 1 }"
          @click="change_top_button5(1)"
        >
          ROA({{chart6_data_2}}%)
        </div>
        <div
          class="box10_top_button_button1"
          :class="{ box10_top_button_button2: bxjj_navigation5 == 2 }"
          @click="change_top_button5(2)"
        >
          ROIC({{chart6_data_3}}%)
        </div>
      </div>
      <div class="box10_top_legend_box">
        <div class="box10_top_legend_box_option1">
          <div class="box10_top_legend_box_option1_colordiv"></div>
          格力电器
        </div>
        <div class="box10_top_legend_box_option1">
          <div class="box10_top_legend_box_option2_colordiv"></div>
          白色家电
        </div>
      </div>
      <Chart6 ref="chart6" :chart6_data_x='chart6_data_x' :chart6_data_y='chart6_data_y' :chart6_data_y2='chart6_data_y2' :chart6_data_table='chart6_data_table'></Chart6>
    </div>

    <div class="box11">
      <div class="box11_top_title">
        <div class="box11_top_title_text1">盈利能力-利润率</div>
        <div class="box20_top_title_text3">
          <img
            style="width: 15px; vertical-align: middle; margin-left: 3px"
            src="../../../public/img/shares_Info/yiwen_yellow.png"
            alt=""
            @click="frame12_open"
          />
        </div>
        <div class="box11_top_title_text2">
          切换对比<img
            style="width: 9px; vertical-align: middle; margin-left: 3px"
            src="../../../public/img/shares_Info/qiehuan.png"
            alt=""
          />
        </div>
      </div>
      <div class="box11_top_button">
        <div
          class="box11_top_button_button1"
          :class="{ box11_top_button_button2: bxjj_navigation6 == 0 }"
          @click="change_top_button6(0)"
        >
          毛利率({{chart7_data_1}}%)
        </div>
        <div
          class="box11_top_button_button1"
          :class="{ box11_top_button_button2: bxjj_navigation6 == 1 }"
          @click="change_top_button6(1)"
        >
          净利率({{chart7_data_2}}%)
        </div>
        <div
          class="box11_top_button_button1"
          :class="{ box11_top_button_button2: bxjj_navigation6 == 2 }"
          @click="change_top_button6(2)"
        >
          营业利润率({{chart7_data_3}}%)
        </div>
      </div>
      <div class="box11_top_legend_box">
        <div class="box11_top_legend_box_option1">
          <div class="box11_top_legend_box_option1_colordiv"></div>
          格力电器
        </div>
        <div class="box11_top_legend_box_option1">
          <div class="box11_top_legend_box_option2_colordiv"></div>
          白色家电
        </div>
      </div>
      <Chart7 ref="chart7" :chart7_data_x='chart7_data_x' :chart7_data_y='chart7_data_y' :chart7_data_y2='chart7_data_y2' :chart7_data_table='chart7_data_table'></Chart7>
    </div>

    <div class="box12">
      <div class="box12_top_title">
        <div class="box12_top_title_text1">盈利能力-费用率</div>
        <div class="box20_top_title_text3">
          <img
            style="width: 15px; vertical-align: middle; margin-left: 3px"
            src="../../../public/img/shares_Info/yiwen_yellow.png"
            alt=""
            @click="frame13_open"
          />
        </div>
        <div class="box12_top_title_text2">
          切换对比<img
            style="width: 9px; vertical-align: middle; margin-left: 3px"
            src="../../../public/img/shares_Info/qiehuan.png"
            alt=""
          />
        </div>
      </div>
      <div class="box12_top_button">
        <div
          class="box12_top_button_button1"
          :class="{ box12_top_button_button2: bxjj_navigation7 == 0 }"
          @click="change_top_button7(0)"
        >
          总费用(23.7%)
        </div>
        <div
          class="box12_top_button_button1"
          :class="{ box12_top_button_button2: bxjj_navigation7 == 1 }"
          @click="change_top_button7(1)"
        >
          财务费用(1.84%)
        </div>
        <div
          class="box12_top_button_button1"
          :class="{ box12_top_button_button2: bxjj_navigation7 == 2 }"
          @click="change_top_button7(2)"
        >
          研发费用(7.91%)
        </div>
        <div
          class="box12_top_button_button1"
          :class="{ box12_top_button_button2: bxjj_navigation7 == 3 }"
          @click="change_top_button7(3)"
        >
          管理费用(11.2%)
        </div>
        <div
          class="box12_top_button_button1"
          :class="{ box12_top_button_button2: bxjj_navigation7 == 4 }"
          @click="change_top_button7(4)"
        >
          销售费用(2.76%)
        </div>
      </div>
      <div class="box12_top_legend_box">
        <div class="box12_top_legend_box_option1">
          <div class="box12_top_legend_box_option1_colordiv"></div>
          股息率
        </div>
        <div class="box12_top_legend_box_option1">
          <div class="box12_top_legend_box_option2_colordiv"></div>
          股利支付率
        </div>
      </div>
      <Chart8 ref="chart8" :chart8_data_x='chart8_data_x' :chart8_data_y='chart8_data_y' :chart8_data_y2='chart8_data_y2' :chart8_data_table='chart8_data_table'></Chart8>
    </div>

    <div class="box13">
      <div class="box13_top_title">
        <div class="box13_top_title_text1">PE/PB Band</div>
        <div class="box20_top_title_text3">
          <img
            style="width: 15px; vertical-align: middle; margin-left: 3px"
            src="../../../public/img/shares_Info/yiwen_yellow.png"
            alt=""
            @click="frame14_open"
          />
        </div>
        <div class="box13_top_title_text2">
          最近十年<img
            style="width: 9px; vertical-align: middle; margin-left: 3px"
            src="../../../public/img/shares_Info/xiala_bottom_yellow.png"
            alt=""
          />
        </div>
      </div>
      <div class="box13_top_tip1">分红</div>
      <div class="box13_top_tip2">
        二十六年前买入，不考虑红利再投，年化股息收益率为
        <i class="i1">22.63%</i> ，股利支付率为 <i class="i1">49.79%</i>
      </div>
      <div class="box13_top_legend_box">
        <div class="box13_top_legend_box_option1">
          <div class="box13_top_legend_box_option1_colordiv"></div>
          格力电器
        </div>
        <div class="box13_top_legend_box_option1">
          <div class="box13_top_legend_box_option2_colordiv"></div>
          白色家电
        </div>
      </div>
      <Chart9></Chart9>
      <div class="box13_technological_process">
        <div class="box13_technological_process_box1">
          <div class="box13_technological_process_box1_title">
            2021半年报:每股派1.000元
          </div>
          <div class="box13_technological_process_box1_bootom">
            <div class="box13_technological_process_box1_bootom_option1">
              <div
                class="box13_technological_process_box1_bootom_option1_jindu"
              >
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu1
                    box13_technological_process_box1_bootom_option1_jindu_jindu12
                  "
                ></div>
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu2
                    box13_technological_process_box1_bootom_option1_jindu_jindu22
                  "
                ></div>
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu3
                  "
                ></div>
              </div>
              <div
                class="box13_technological_process_box1_bootom_option1_text1"
              >
                预案公告
              </div>
              <div
                class="box13_technological_process_box1_bootom_option1_text2"
              >
                21-08-23
              </div>
            </div>
            <div class="box13_technological_process_box1_bootom_option1">
              <div
                class="box13_technological_process_box1_bootom_option1_jindu"
              >
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu1
                  "
                ></div>
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu2
                  "
                ></div>
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu3
                  "
                ></div>
              </div>
              <div
                class="box13_technological_process_box1_bootom_option1_text1"
              >
                股东大会
              </div>
              <div
                class="box13_technological_process_box1_bootom_option1_text2"
              >
                21-08-23
              </div>
            </div>
            <div class="box13_technological_process_box1_bootom_option1">
              <div
                class="box13_technological_process_box1_bootom_option1_jindu"
              >
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu1
                  "
                ></div>
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu2
                  "
                ></div>
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu3
                  "
                ></div>
              </div>
              <div
                class="box13_technological_process_box1_bootom_option1_text1"
              >
                股权登记
              </div>
              <div
                class="box13_technological_process_box1_bootom_option1_text2"
              >
                21-08-23
              </div>
            </div>
            <div class="box13_technological_process_box1_bootom_option1">
              <div
                class="box13_technological_process_box1_bootom_option1_jindu"
              >
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu1
                  "
                ></div>
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu2
                  "
                ></div>
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu3
                  "
                ></div>
              </div>
              <div
                class="box13_technological_process_box1_bootom_option1_text1"
              >
                派息日
              </div>
              <div
                class="box13_technological_process_box1_bootom_option1_text2"
              >
                21-08-23
              </div>
            </div>
          </div>
        </div>
        <div class="box13_technological_process_box1">
          <div class="box13_technological_process_box1_title">
            2021半年报:每股派1.000元
          </div>
          <div class="box13_technological_process_box1_bootom">
            <div class="box13_technological_process_box1_bootom_option1">
              <div
                class="box13_technological_process_box1_bootom_option1_jindu"
              >
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu1
                    box13_technological_process_box1_bootom_option1_jindu_jindu12
                  "
                ></div>
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu2
                    box13_technological_process_box1_bootom_option1_jindu_jindu22
                  "
                ></div>
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu3
                    box13_technological_process_box1_bootom_option1_jindu_jindu32
                  "
                ></div>
              </div>
              <div
                class="box13_technological_process_box1_bootom_option1_text1"
              >
                预案公告
              </div>
              <div
                class="box13_technological_process_box1_bootom_option1_text2"
              >
                21-08-23
              </div>
            </div>
            <div class="box13_technological_process_box1_bootom_option1">
              <div
                class="box13_technological_process_box1_bootom_option1_jindu"
              >
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu1
                    box13_technological_process_box1_bootom_option1_jindu_jindu12
                  "
                ></div>
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu2
                    box13_technological_process_box1_bootom_option1_jindu_jindu22
                  "
                ></div>
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu3
                  "
                ></div>
              </div>
              <div
                class="box13_technological_process_box1_bootom_option1_text1"
              >
                股东大会
              </div>
              <div
                class="box13_technological_process_box1_bootom_option1_text2"
              >
                21-08-23
              </div>
            </div>
            <div class="box13_technological_process_box1_bootom_option1">
              <div
                class="box13_technological_process_box1_bootom_option1_jindu"
              >
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu1
                  "
                ></div>
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu2
                  "
                ></div>
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu3
                  "
                ></div>
              </div>
              <div
                class="box13_technological_process_box1_bootom_option1_text1"
              >
                股权登记
              </div>
              <div
                class="box13_technological_process_box1_bootom_option1_text2"
              >
                21-08-23
              </div>
            </div>
            <div class="box13_technological_process_box1_bootom_option1">
              <div
                class="box13_technological_process_box1_bootom_option1_jindu"
              >
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu1
                  "
                ></div>
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu2
                  "
                ></div>
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu3
                  "
                ></div>
              </div>
              <div
                class="box13_technological_process_box1_bootom_option1_text1"
              >
                派息日
              </div>
              <div
                class="box13_technological_process_box1_bootom_option1_text2"
              >
                21-08-23
              </div>
            </div>
          </div>
        </div>
        <div class="box13_technological_process_box1">
          <div class="box13_technological_process_box1_title">
            2021半年报:每股派1.000元
          </div>
          <div class="box13_technological_process_box1_bootom">
            <div class="box13_technological_process_box1_bootom_option1">
              <div
                class="box13_technological_process_box1_bootom_option1_jindu"
              >
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu1
                    box13_technological_process_box1_bootom_option1_jindu_jindu12
                  "
                ></div>
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu2
                    box13_technological_process_box1_bootom_option1_jindu_jindu22
                  "
                ></div>
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu3
                    box13_technological_process_box1_bootom_option1_jindu_jindu32
                  "
                ></div>
              </div>
              <div
                class="box13_technological_process_box1_bootom_option1_text1"
              >
                预案公告
              </div>
              <div
                class="box13_technological_process_box1_bootom_option1_text2"
              >
                21-08-23
              </div>
            </div>
            <div class="box13_technological_process_box1_bootom_option1">
              <div
                class="box13_technological_process_box1_bootom_option1_jindu"
              >
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu1
                    box13_technological_process_box1_bootom_option1_jindu_jindu12
                  "
                ></div>
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu2
                    box13_technological_process_box1_bootom_option1_jindu_jindu22
                  "
                ></div>
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu3
                    box13_technological_process_box1_bootom_option1_jindu_jindu32
                  "
                ></div>
              </div>
              <div
                class="box13_technological_process_box1_bootom_option1_text1"
              >
                股东大会
              </div>
              <div
                class="box13_technological_process_box1_bootom_option1_text2"
              >
                21-08-23
              </div>
            </div>
            <div class="box13_technological_process_box1_bootom_option1">
              <div
                class="box13_technological_process_box1_bootom_option1_jindu"
              >
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu1
                    box13_technological_process_box1_bootom_option1_jindu_jindu12
                  "
                ></div>
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu2
                    box13_technological_process_box1_bootom_option1_jindu_jindu22
                  "
                ></div>
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu3
                  "
                ></div>
              </div>
              <div
                class="box13_technological_process_box1_bootom_option1_text1"
              >
                股权登记
              </div>
              <div
                class="box13_technological_process_box1_bootom_option1_text2"
              >
                21-08-23
              </div>
            </div>
            <div class="box13_technological_process_box1_bootom_option1">
              <div
                class="box13_technological_process_box1_bootom_option1_jindu"
              >
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu1
                  "
                ></div>
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu2
                  "
                ></div>
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu3
                  "
                ></div>
              </div>
              <div
                class="box13_technological_process_box1_bootom_option1_text1"
              >
                派息日
              </div>
              <div
                class="box13_technological_process_box1_bootom_option1_text2"
              >
                21-08-23
              </div>
            </div>
          </div>
        </div>
        <div class="box13_technological_process_box1">
          <div class="box13_technological_process_box1_title">
            2021半年报:每股派1.000元
          </div>
          <div class="box13_technological_process_box1_bootom">
            <div class="box13_technological_process_box1_bootom_option1">
              <div
                class="box13_technological_process_box1_bootom_option1_jindu"
              >
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu1
                    box13_technological_process_box1_bootom_option1_jindu_jindu12
                  "
                ></div>
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu2
                    box13_technological_process_box1_bootom_option1_jindu_jindu22
                  "
                ></div>
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu3
                    box13_technological_process_box1_bootom_option1_jindu_jindu32
                  "
                ></div>
              </div>
              <div
                class="box13_technological_process_box1_bootom_option1_text1"
              >
                预案公告
              </div>
              <div
                class="box13_technological_process_box1_bootom_option1_text2"
              >
                21-08-23
              </div>
            </div>
            <div class="box13_technological_process_box1_bootom_option1">
              <div
                class="box13_technological_process_box1_bootom_option1_jindu"
              >
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu1
                    box13_technological_process_box1_bootom_option1_jindu_jindu12
                  "
                ></div>
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu2
                    box13_technological_process_box1_bootom_option1_jindu_jindu22
                  "
                ></div>
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu3
                    box13_technological_process_box1_bootom_option1_jindu_jindu32
                  "
                ></div>
              </div>
              <div
                class="box13_technological_process_box1_bootom_option1_text1"
              >
                股东大会
              </div>
              <div
                class="box13_technological_process_box1_bootom_option1_text2"
              >
                21-08-23
              </div>
            </div>
            <div class="box13_technological_process_box1_bootom_option1">
              <div
                class="box13_technological_process_box1_bootom_option1_jindu"
              >
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu1
                    box13_technological_process_box1_bootom_option1_jindu_jindu12
                  "
                ></div>
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu2
                    box13_technological_process_box1_bootom_option1_jindu_jindu22
                  "
                ></div>
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu3
                    box13_technological_process_box1_bootom_option1_jindu_jindu32
                  "
                ></div>
              </div>
              <div
                class="box13_technological_process_box1_bootom_option1_text1"
              >
                股权登记
              </div>
              <div
                class="box13_technological_process_box1_bootom_option1_text2"
              >
                21-08-23
              </div>
            </div>
            <div class="box13_technological_process_box1_bootom_option1">
              <div
                class="box13_technological_process_box1_bootom_option1_jindu"
              >
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu1
                    box13_technological_process_box1_bootom_option1_jindu_jindu12
                  "
                ></div>
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu2
                    box13_technological_process_box1_bootom_option1_jindu_jindu22
                  "
                ></div>
                <div
                  class="
                    box13_technological_process_box1_bootom_option1_jindu_jindu3
                    box13_technological_process_box1_bootom_option1_jindu_jindu32
                  "
                ></div>
              </div>
              <div
                class="box13_technological_process_box1_bootom_option1_text1"
              >
                派息日
              </div>
              <div
                class="box13_technological_process_box1_bootom_option1_text2"
              >
                21-08-23
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box13_fyq">
        <el-pagination
          background
          layout="pager, next"
          :total="50"
        ></el-pagination>
      </div>
      <div class="box13_top_tip3">募资</div>
      <div class="box13_top_tip4">
        上市以来，分红金额为募资金额的
        <i class="i1">1726.54%</i> ，在全部A股中排名 <i class="i1">9/4728</i>
      </div>
      <div class="box13_top_legend_box">
        <div class="box13_top_legend_box_option1">
          <div class="box13_top_legend_box_option3_colordiv"></div>
          首发
        </div>
        <div class="box13_top_legend_box_option1">
          <div class="box13_top_legend_box_option4_colordiv"></div>
          增发
        </div>
        <div class="box13_top_legend_box_option1">
          <div class="box13_top_legend_box_option5_colordiv"></div>
          配股
        </div>
        <div class="box13_top_legend_box_option1">
          <div class="box13_top_legend_box_option6_colordiv"></div>
          现金分红
        </div>
      </div>
      <Chart10></Chart10>
    </div>

    <div class="box14">
      <div class="box14_top_title">
        <div class="box14_top_title_text1">现金流量</div>
        <div class="box20_top_title_text3">
          <img
            style="width: 15px; vertical-align: middle; margin-left: 3px"
            src="../../../public/img/shares_Info/yiwen_yellow.png"
            alt=""
            @click="frame15_open"
          />
        </div>
        <div class="box14_top_title_text2">
          按季度<img
            style="width: 9px; vertical-align: middle; margin-left: 3px"
            src="../../../public/img/shares_Info/xiala_bottom_yellow.png"
            alt=""
          />
        </div>
      </div>
      <div class="box14_top_button">
        <div
          class="box14_top_button_button1"
          :class="{ box14_top_button_button2: bxjj_navigation8 == 0 }"
          @click="change_top_button8(0)"
        >
          概览(+--)
        </div>
        <div
          class="box14_top_button_button1"
          :class="{ box14_top_button_button2: bxjj_navigation8 == 1 }"
          @click="change_top_button8(1)"
        >
          净现比(94.0%)
        </div>
        <div
          class="box14_top_button_button1"
          :class="{ box14_top_button_button2: bxjj_navigation8 == 2 }"
          @click="change_top_button8(2)"
        >
          收现比(105%)
        </div>
      </div>
      <div class="box14_top_legend_box">
        <div class="box14_top_legend_box_option1">
          <div class="box14_top_legend_box_option1_colordiv"></div>
          经营现金流
        </div>
        <div class="box14_top_legend_box_option1">
          <div class="box14_top_legend_box_option2_colordiv"></div>
          投资现金流
        </div>
        <div class="box14_top_legend_box_option1">
          <div class="box14_top_legend_box_option3_colordiv"></div>
          筹资现金流
        </div>
      </div>
      <Chart11></Chart11>
    </div>

    <div class="box15">
      <div class="box15_top_title">
        <div class="box15_top_title_text1">主营构成</div>
          <div class="box14_top_title_text2" v-if="this.zygc_type == 1" @click="change_zygc(2)">最新一期<img style="width: 9px; vertical-align: middle; margin-left: 3px" src="../../../public/img/shares_Info/xiala_bottom_yellow.png"/></div>
          <div class="box14_top_title_text2" v-else @click="change_zygc(1)">最近十年<img style="width: 9px; vertical-align: middle; margin-left: 3px" src="../../../public/img/shares_Info/xiala_bottom_yellow.png"/></div>
      </div>
      <div class="box15_top_button">
        <div
          class="box15_top_button_button1"
          :class="{ box15_top_button_button2: bxjj_navigation9 == 0 }"
          @click="change_top_button9(0)"
        >
          按产品
        </div>
        <div
          class="box15_top_button_button1"
          :class="{ box15_top_button_button2: bxjj_navigation9 == 1 }"
          @click="change_top_button9(1)"
        >
          按地区
        </div>
        <div
          class="box15_top_button_button1"
          :class="{ box15_top_button_button2: bxjj_navigation9 == 2 }"
          @click="change_top_button9(2)"
        >
          按行业
        </div>
      </div>
      <div class="box15_bottom">
        <div v-if="zygc_type == 1">
          <el-table
            :data="tableData2"
            border
            style="width: 100%"
            header-row-class-name="back_hui"
          >
            <el-table-column
              type='index'
              label="序号"
              width="100"
              align="center"
            ></el-table-column>
            <el-table-column prop="ths_moc_project_name" label="名称"></el-table-column>
            <el-table-column
              prop="ths_moc_project_gross"
              label="毛利率"
              width="120"
              align="center"
            >
            <template slot-scope="scope">{{scope.row.ths_moc_project_gross}} <i v-if="scope.row.ths_moc_project_gross">%</i></template>
            </el-table-column>
            <el-table-column
              prop="ths_moc_project_income"
              label="营收占比"
              width="120"
              align="center"
            >
            <template slot-scope="scope">{{scope.row.ths_moc_project_income}} <i v-if="scope.row.ths_moc_project_income">%</i></template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else>
          <Chart19 ref="chart19" :chart19_data_option='chart19_data_option'></Chart19>
        </div>
      </div>
    </div>

    <div class="box16">
      <div class="box16_top_title">
        <div class="box16_top_title_text1">营运能力</div>
        <div class="box20_top_title_text3">
          <img
            style="width: 15px; vertical-align: middle; margin-left: 3px"
            src="../../../public/img/shares_Info/yiwen_yellow.png"
            alt=""
            @click="frame16_open"
          />
        </div>
        <div class="box16_top_title_text2">
          按周转率<img
            style="width: 9px; vertical-align: middle; margin-left: 3px"
            src="../../../public/img/shares_Info/qiehuan.png"
            alt=""
          />
        </div>
      </div>
      <div class="box16_top_button">
        <div
          class="box16_top_button_button1"
          :class="{ box16_top_button_button2: bxjj_navigation6 == 0 }"
          @click="change_top_button6(0)"
        >
          存货周转(4.39次)
        </div>
        <div
          class="box16_top_button_button1"
          :class="{ box16_top_button_button2: bxjj_navigation6 == 1 }"
          @click="change_top_button6(1)"
        >
          应收账款周转(11.6次)
        </div>
        <div
          class="box16_top_button_button1"
          :class="{ box16_top_button_button2: bxjj_navigation6 == 2 }"
          @click="change_top_button6(2)"
        >
          总资产周转(0.65次)
        </div>
      </div>
      <div class="box16_top_legend_box">
        <div class="box16_top_legend_box_option1">
          <div class="box16_top_legend_box_option1_colordiv"></div>
          格力电器
        </div>
        <div class="box16_top_legend_box_option1">
          <div class="box16_top_legend_box_option2_colordiv"></div>
          白色家电
        </div>
      </div>
      <Chart12></Chart12>
    </div>
    <div class="box17">
      <div class="box17_top_title">
        <div class="box17_top_title_text1">投资评级</div>
        <div class="box17_top_title_text3">
          <img
            style="width: 15px; vertical-align: middle; margin-left: 3px"
            src="../../../public/img/shares_Info/yiwen_yellow.png"
            alt=""
            @click="frame17_open"
          />
        </div>
      </div>
      <div class="box17_top_tip1">
        最近90天共 <i class="i1">4</i> 家机构给出评级。综合投资评级为
        <i class="i1">买入</i> ，对应数值为 <i class="i1">1</i>
      </div>
      <Chart13></Chart13>
    </div>
    <div class="box18">
      <div class="box18_top_title">
        <div class="box18_top_title_text1">机构目标价</div>
        <div class="box18_top_title_text3">
          <img
            style="width: 15px; vertical-align: middle; margin-left: 3px"
            src="../../../public/img/shares_Info/yiwen_yellow.png"
            alt=""
            @click="frame18_open"
          />
        </div>
      </div>
      <div class="box18_top_tip1">
        股票当前价为1804.19，机构目标均价为 <i class="i1">2392.98</i> ,上涨空间
        <i class="i1">32.63%</i>
      </div>
      <div class="box18_top_legend_box">
        <div class="box18_top_legend_box_option1">
          <div class="box18_top_legend_box_option1_colordiv"></div>
          预测最低
        </div>
        <div class="box18_top_legend_box_option1">
          <div class="box18_top_legend_box_option2_colordiv"></div>
          目标均价
        </div>
        <div class="box18_top_legend_box_option1">
          <div class="box18_top_legend_box_option3_colordiv"></div>
          预测最高
        </div>
      </div>
      <Chart14></Chart14>
    </div>
    <div class="box19">
      <div class="box19_top_title">
        <div class="box19_top_title_text1">盈利预测</div>
        <div class="box19_top_title_text3">
          <img
            style="width: 15px; vertical-align: middle; margin-left: 3px"
            src="../../../public/img/shares_Info/yiwen_yellow.png"
            alt=""
            @click="frame19_open"
          />
        </div>
      </div>
      <div class="box19_bottom">
        <el-table
          :data="tableData3"
          border
          style="width: 100%"
          header-row-class-name="back_hui"
        >
          <el-table-column
            prop="date"
            label="名称"
            min-width="25%"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="data2"
            label="2022"
            min-width="25%"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="data3"
            label="2033"
            min-width="25%"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="data1"
            label="2021"
            min-width="25%"
            align="center"
          ></el-table-column>
        </el-table>
      </div>
    </div>

    <div class="box20">
      <div class="box20_top_title">
        <div class="box20_top_title_text1">RPS股价相对强度</div>
        <div class="box20_top_title_text3">
          <img
            style="width: 15px; vertical-align: middle; margin-left: 3px"
            src="../../../public/img/shares_Info/yiwen_yellow.png"
            alt=""
            @click="frame20_open"
          />
        </div>
        <div class="box20_top_title_text2">
          切换对比<img
            style="width: 9px; vertical-align: middle; margin-left: 3px"
            src="../../../public/img/shares_Info/qiehuan.png"
            alt=""
          />
        </div>
      </div>
      <div class="box20_top_button">
        <div
          class="box20_top_button_button1"
          :class="{ box20_top_button_button2: bxjj_navigation10 == 0 }"
          @click="change_top_button6(0)"
        >
          RPS10(28.4%)
        </div>
        <div
          class="box20_top_button_button1"
          :class="{ box20_top_button_button2: bxjj_navigation10 == 1 }"
          @click="change_top_button6(1)"
        >
          RPS20(75.6%)
        </div>
        <div
          class="box20_top_button_button1"
          :class="{ box20_top_button_button2: bxjj_navigation10 == 2 }"
          @click="change_top_button6(2)"
        >
          RPS60(59.9%)
        </div>
        <div
          class="box20_top_button_button1"
          :class="{ box20_top_button_button2: bxjj_navigation10 == 2 }"
          @click="change_top_button6(2)"
        >
          RPS120(73.0%)
        </div>
        <div
          class="box20_top_button_button1"
          :class="{ box20_top_button_button2: bxjj_navigation10 == 2 }"
          @click="change_top_button6(2)"
        >
          RPS250(16.4%)
        </div>
      </div>
      <div class="box20_top_legend_box">
        <div class="box20_top_legend_box_option1">
          <div class="box20_top_legend_box_option1_colordiv"></div>
          格力电器
        </div>
        <div class="box20_top_legend_box_option1">
          <div class="box20_top_legend_box_option2_colordiv"></div>
          白色家电
        </div>
      </div>
      <Chart15></Chart15>
    </div>

    <div class="box21">
      <div class="box21_top_title">
        <div class="box21_top_title_text1">北向资金持股</div>
        <div class="box21_top_title_text3">
          <img
            style="width: 15px; vertical-align: middle; margin-left: 3px"
            src="../../../public/img/shares_Info/yiwen_yellow.png"
            alt=""
            @click="frame21_open"
          />
        </div>
      </div>
      <div class="box21_top_legend_box">
        <div class="box21_top_legend_box_option1">
          <div class="box21_top_legend_box_option1_colordiv"></div>
          占流通A股(左)
        </div>
        <div class="box21_top_legend_box_option1">
          <div class="box21_top_legend_box_option2_colordiv"></div>
          股价(右)
        </div>
      </div>
      <Chart16></Chart16>
    </div>

    <div class="box22">
      <div class="box22_top_title">
        <div class="box22_top_title_text1">股东户数变化</div>
        <div class="box22_top_title_text3">
          <img
            style="width: 15px; vertical-align: middle; margin-left: 3px"
            src="../../../public/img/shares_Info/yiwen_yellow.png"
            alt=""
          />
        </div>
      </div>
      <div class="box22_top_legend_box">
        <div class="box22_top_legend_box_option1">
          <div class="box22_top_legend_box_option1_colordiv"></div>
          股东户数
        </div>
        <div class="box22_top_legend_box_option1">
          <div class="box22_top_legend_box_option2_colordiv"></div>
          股价(右)
        </div>
      </div>
      <Chart17 ref="chart17" :chart17_data_x='chart17_data_x' :chart17_data_y='chart17_data_y' :chart17_data_y2='chart17_data_y2'></Chart17>
    </div>

    <div class="box23">
      <div class="box23_top_title">
        <div class="box23_top_title_text1">盈利预测</div>
      </div>
      <div class="box23_bottom">
        <el-table
          :data="tableData4"
          border
          style="width: 100%"
          header-row-class-name="back_hui"
        >
          <el-table-column
            prop="date"
            label="北向资金"
            min-width="16.6%"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="data1"
            label="基金"
            min-width="16.6%"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="data2"
            label="券商"
            min-width="16.6%"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="data3"
            label="QFI"
            min-width="16.6%"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="data4"
            label="券商"
            min-width="16.6%"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="data5"
            label="QFI"
            min-width="16.6%"
            align="center"
          ></el-table-column>
        </el-table>
      </div>
    </div>

    <div class="box24">
      <div class="box24_top_title">
        <div class="box24_top_title_text1">盈利预测</div>
      </div>
      <div class="box24_bottom">
        <el-table
          :data="tableData5"
          border
          style="width: 100%"
          header-row-class-name="back_hui"
        >
          <el-table-column
            prop="date"
            label="序号"
            width="80"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="data1"
            label="股东名称"
            align="left"
          ></el-table-column>
          <el-table-column
            prop="data2"
            label="持股比例"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="data3"
            label="质押占持股"
            width="120"
            align="center"
          ></el-table-column>
        </el-table>
      </div>
    </div>

    <div class="box25">
      <div class="box25_top_title">
        <div class="box25_top_title_text1">主力资金流向</div>
      </div>
      <Chart18></Chart18>
    </div>
    <div
      style="width: 100vw; height: 100vh; background-color: rgba(0, 0, 0, 0.3)"
      class="tuceng"
      v-show="
        frame1_show ||
        frame2_show ||
        frame3_show ||
        frame4_show ||
        frame5_show ||
        frame6_show ||
        frame7_show ||
        frame10_show ||
        frame11_show ||
        frame12_show ||
        frame13_show ||
        frame14_show ||
        frame15_show ||
        frame16_show ||
        frame17_show ||
        frame18_show ||
        frame19_show ||
        frame20_show ||
        frame21_show
      "
    ></div>
    <Frame1 v-show="frame1_show" @close_prame1="close_prame1" :intro='intro'></Frame1>
    <Frame2 v-show="frame2_show" @frame2_close="frame2_close"></Frame2>
    <Frame3 v-show="frame3_show"></Frame3>
    <Frame4 v-show="frame4_show"></Frame4>
    <Frame5 v-show="frame5_show"></Frame5>
    <Frame6 v-show="frame6_show"></Frame6>
    <Frame7 v-show="frame7_show"></Frame7>
    <Frame8 v-show="frame8_show" @frame8_close="frame8_close"></Frame8>
    <Frame9 v-show="frame9_show" @frame9_close="frame9_close"></Frame9>
    <Frame10 v-show="frame10_show" @frame10_close="frame10_close"></Frame10>
    <Frame11 v-show="frame11_show" @frame11_close="frame11_close"></Frame11>
    <Frame12 v-show="frame12_show" @frame12_close="frame12_close"></Frame12>
    <Frame13 v-show="frame13_show" @frame13_close="frame13_close"></Frame13>
    <Frame14 v-show="frame14_show" @frame14_close="frame14_close"></Frame14>
    <Frame15 v-show="frame15_show" @frame15_close="frame15_close"></Frame15>
    <Frame16 v-show="frame16_show" @frame16_close="frame16_close"></Frame16>
    <Frame17 v-show="frame17_show" @frame17_close="frame17_close"></Frame17>
    <Frame18 v-show="frame18_show" @frame18_close="frame18_close"></Frame18>
    <Frame19 v-show="frame19_show" @frame19_close="frame19_close"></Frame19>
    <Frame20 v-show="frame20_show" @frame20_close="frame20_close"></Frame20>
    <Frame21 v-show="frame21_show" @frame21_close="frame21_close"></Frame21>
  </div>
</template>

<script>
import { stockValuation ,stockGrowthAbility,stockProfitMargin,stockDupontAnalysis,stockCapitalReturn,stockCapitalCost,stockSHNumber,stockBasicData,stockIntroduce,stockMainBusiness,stockPePbBand} from '../../http/shares.js'
import Chart1 from "./chart/chart1.vue";
import Chart2 from "./chart/chart2.vue";
import Chart3 from "./chart/chart3.vue";
import Chart4 from "./chart/chart4.vue";
import Chart42 from "./chart/chart42.vue";
import Chart5 from "./chart/chart5.vue";
import Chart6 from "./chart/chart6.vue";
import Chart7 from "./chart/chart7.vue";
import Chart8 from "./chart/chart8.vue";
import Chart9 from "./chart/chart9.vue";
import Chart10 from "./chart/chart10.vue";
import Chart11 from "./chart/chart11.vue";
import Chart12 from "./chart/chart12.vue";
import Chart13 from "./chart/chart13.vue";
import Chart14 from "./chart/chart14.vue";
import Chart15 from "./chart/chart15.vue";
import Chart16 from "./chart/chart16.vue";
import Chart17 from "./chart/chart17.vue";
import Chart18 from "./chart/chart18.vue";
import Chart19 from "./chart/chart19.vue";
import Chart20 from "./chart/chart20.vue";
import Chart21 from "./chart/chart21.vue";
import Frame1 from "./frame/frame1.vue";
import Frame2 from "./frame/frame2.vue";
import Frame3 from "./frame/frame3.vue";
import Frame4 from "./frame/frame4.vue";
import Frame5 from "./frame/frame5.vue";
import Frame6 from "./frame/frame6.vue";
import Frame7 from "./frame/frame7.vue";
import Frame8 from "./frame/frame8.vue";
import Frame9 from "./frame/frame9.vue";
import Frame10 from "./frame/frame10.vue";
import Frame11 from "./frame/frame11.vue";
import Frame12 from "./frame/frame12.vue";
import Frame13 from "./frame/frame13.vue";
import Frame14 from "./frame/frame14.vue";
import Frame15 from "./frame/frame15.vue";
import Frame16 from "./frame/frame16.vue";
import Frame17 from "./frame/frame17.vue";
import Frame18 from "./frame/frame18.vue";
import Frame19 from "./frame/frame19.vue";
import Frame20 from "./frame/frame20.vue";
import Frame21 from "./frame/frame21.vue";
export default {
  data() {
    return {
      change_option: 0, //  k线图 点击样式切换
      bxjj_navigation: 0, //  大事提醒  点击样式切换
      bxjj_navigation2: 0, //  估值与分位  点击样式切换
      bxjj_navigation3: 0, //  PE/PB Band  点击样式切换
      bxjj_navigation4: 0, //  成长能力  点击样式切换
      bxjj_navigation5: 0, //  盈利能力-回报率  点击样式切换
      bxjj_navigation6: 0, //  盈利能力-利润率  点击样式切换
      bxjj_navigation7: 0, //  盈利能力-费用率  点击样式切换
      bxjj_navigation8: 0, //  现金流量  点击样式切换
      bxjj_navigation9: 0, //  主营构成  点击样式切换
      bxjj_navigation10: 0, //  相对强度  点击样式切换
      frame1_show: false,
      frame2_show: false,
      frame3_show: false,
      frame4_show: false,
      frame5_show: false,
      frame6_show: false,
      frame7_show: false,
      frame8_show: true,
      frame9_show: true,
      frame10_show: false,
      frame11_show: false,
      frame12_show: false,
      frame13_show: false,
      frame14_show: false,
      frame15_show: false,
      frame16_show: false,
      frame17_show: false,
      frame18_show: false,
      frame19_show: false,
      frame20_show: false,
      frame21_show: false,
      box3_show: false,
      box4_show: false,
      box5_null: false,
      tableData: [
        {
          date: "2000-04-18",
          data1: "+36.4%",
          data2: "+63.0%",
          data3: "+55.8%",
          data4: "+75.7%",
        },
        {
          date: "2000-04-18",
          data1: "+23.1%",
          data2: "-0.4%",
          data3: "+45.2%",
          data4: "+45.0%",
        },
        {
          date: "2000-04-18",
          data1: "+23.2%",
          data2: "-0.4%",
          data3: "+45.5%",
          data4: "+45.9%",
        },
      ],
      tableData2: [],
      tableData3: [
        {
          date: "市盈率",
          data1: "45.2",
          data2: "48.8",
          data3: "33.1",
        },
        {
          date: "净利润",
          data1: "522亿",
          data2: "613亿",
          data3: "712亿",
        },
        {
          date: "每股收益",
          data1: "41.5",
          data2: "48.8",
          data3: "56.7",
        },
        {
          date: "同比增长",
          data1: "11.7%",
          data2: "17.5%",
          data3: "16.2%",
        },
        {
          date: "PEG",
          data1: "2.99",
          data2: "2.55",
          data3: "2.19",
        },
      ],
      tableData4: [
        {
          date: "7.05%",
          data1: "6.92%",
          data2: "0.13%",
          data3: "0.05%",
          data4: "0%",
          data5: "0%",
        },
      ],
      tableData5: [
        {
          date: "1",
          data1: "中国贵州茅台酒厂(集团)有限责任公司",
          data2: "54.0%",
          data3: "0%",
        },
        {
          date: "2",
          data1: "香港中央结算有限公司(陆股通)",
          data2: "--",
          data3: "2.14%",
        },
        {
          date: "3",
          data1: "贵州省国有资本运营有限责任公司",
          data2: "--",
          data3: "0.22%",
        },
      ],
      headerStyle: {
        background: "red",
      },
      chart2_data_x:[],     //估值与分位 x轴数据
      chart2_data_y:[],     //估值与分位 y轴数据
      chart2_data_y2:[],     //估值与分位 y轴数据
      chart2_data_y3:[],   //估值与分位 y轴数据
      chart2_data_y4:[],   //估值与分位 y轴数据
      chart2_data_1:'',    //
      chart2_data_2:'',    //
      chart2_data_3:'',    //
      chart2_data_4:'',    //
      chart2_data_txt:'',
      chart2_option:1,
      chart4_option:1,
      chart2_option_show:false,
      chart4_option_show:false,
      chart4_data_x:[],
      chart4_data_y:[],
      chart4_data_y2:[],
      chart4_data_y3:[],
      chart4_data_y4:[],
      chart4_data_table:[],
      chart42_data_x:[],
      chart42_data_y:[],
      chart42_data_y2:[],
      chart42_data_table:[],
      chart4_data_1:'',
      chart4_data_2:'',
      chart4_data_3:'',
      chart7_data_x:[],
      chart7_data_y:[],
      chart7_data_y2:[],
      chart7_data_table:[],
      chart5_data_y:[],
      chart5_data_y2:[],
      chart6_data_x:[],
      chart6_data_y:[],
      chart6_data_y2:[],
      chart6_data_table:[],
      chart6_data_1:'',
      chart6_data_2:'',
      chart6_data_3:'',
      chart7_data_1:'',
      chart7_data_2:'',
      chart7_data_3:'',
      chart8_data_x:[],
      chart8_data_y:[],
      chart8_data_y2:[],
      chart8_data_table:[],
      chart17_data_x:[],
      chart17_data_y:[],
      chart17_data_y2:[],
      codes:'',
      information:{},
      intro:[],
      zygc_type:1,
      dw1:'万',
      chart19_data_option:[],
      chart3_data_x:[],
      chart3_data_y:[],
      chart3_data_y2:[],
      chart3_data_y3:[],
      chart3_data_y4:[],
      chart3_data_y5:[],
      chart3_data_y6:[],
      chart3_data_data:{
        val1:'',
        val2:'',
        val3:'',
        val4:'',
        val5:'',
      },
    };
  },
  mounted(){
    let codes = this.$route.params.codes
    let codes2 = codes.slice(0,2)
    let codes3 = codes.slice(2,8)
    let canshu2 = `${codes3}.${codes2}`
    this.codes = canshu2
    
    this.initstockValuation()
    this.initstockGrowthAbility()
    this.initstockProfitMargin()
    this.initstockDupontAnalysis()
    this.initstockCapitalReturn()
    this.initstockCapitalCost()
    this.initstockSHNumber()
    this.initstockBasicData()
    this.initstockIntroduce()
    this.initstockMainBusiness()
    this.initstockPePbBand()
  },
  methods: {
    initstockPePbBand(){
      let codes = this.codes
      let type 
      if(this.bxjj_navigation3 == 0){
        type = 'ths_pe_ttm_stock'
      }else if(this.bxjj_navigation3 == 1){
        type = 'ths_pb_mrq_stock'
      }else if(this.bxjj_navigation3 == 2){
        type = 'ths_ps_ttm_stock'
      }else if(this.bxjj_navigation3 == 3){
        type = 'ths_pcf_operating_cash_flow_ttm_stock'
      }
      stockPePbBand({codes,type}).then((res)=>{
        console.log(res);
        let data = res.data.list
        this.chart3_data_data.val1 = res.data.val1
        this.chart3_data_data.val2 = res.data.val2
        this.chart3_data_data.val3 = res.data.val3
        this.chart3_data_data.val4 = res.data.val4
        this.chart3_data_data.val5 = res.data.val5
        data.map((ele)=>{
          this.chart3_data_x.push(ele.update_time)
          this.chart3_data_y.push(ele.close_price)
          this.chart3_data_y2.push(ele.val1)
          this.chart3_data_y3.push(ele.val2)
          this.chart3_data_y4.push(ele.val3)
          this.chart3_data_y5.push(ele.val4)
          this.chart3_data_y6.push(ele.val5)
          return ele
        })
        setTimeout(() => {
          this.$refs.chart3.myEcharts3()
        });
      }).catch((err)=>{
        console.log(err);
      })
    },
    change_zygc(e){
      this.zygc_type = e
      this.initstockMainBusiness()
    },
    initstockMainBusiness(){
      let codes = this.codes
      let type 
      if(this.bxjj_navigation9 == 0){
        type = 1
      }else if(this.bxjj_navigation9 == 1){
        type = 2
      }else if(this.bxjj_navigation9 == 2){
        type = 3
      }
      let time_len = this.zygc_type
      let params = Object.assign({},{codes,type,time_len})
      stockMainBusiness(params).then((res)=>{
        if(time_len == 1){
          this.tableData2 = res.data.list
        }else if(time_len == 2){
          let data = res.data.list
          this.chart19_data_option = []
          data.map((ele)=>{
            let charts = ele.charts
            let data_x = charts.map((ele2)=>{
              return ele2.time.slice(0,4)
            })
            let data_y = charts.map((ele2)=>{
              return ele2.ths_moc_project_income
            })
            let data_y2 = charts.map((ele2)=>{
              return ele2.ths_moc_project_gross
            })
            let table = []
            charts.map((ele2)=>{
              table.push({data1:ele2.time.slice(0,4),data2:ele2.ths_moc_project_income,data3:ele2.ths_moc_project_gross})
              return ele2
            })
            let option = {
              tooltip: {
                trigger: "axis",
              },
              grid: {
                containLabel: true,
                left: -40,
                right: -40,
                bottom: 0,
              },
              xAxis: {
                axisTick: {
                  show: false,
                  lineStyle: {
                    width: "122",
                  },
                },
                axisLine: {
                  lineStyle: {
                    color: "#ededed",
                  },
                },
                axisLabel: {
                  formatter: function (value) {
                    return ``;
                  },
                },
                data: data_x,
              },
              yAxis: [
                {
                  type: "value",
                  show: false,
                  position: "left",
                },
                {
                  type: "value",
                  show: false,
                  position: "right",
                  axisLabel: {
                    formatter: function (value) {
                      return value + "%";
                    },
                  },
                },
              ],
              series: [
                {
                  name: "营收占比",
                  type: "bar",
                  data: data_y,
                  color: "#fcad2a",
                  barWidth: 16,
                  barGap: "50%",
                },
                {
                  name: "毛利率",
                  type: "line",
                  data: data_y2,
                  color: "#579eff",
                  barWidth: 16,
                  barGap: "50%",
                  yAxisIndex: 1,
                  symbol: "circle",
                  label: {
                    formatter: "{c}%",
                    color: "#579eff",
                    show: true,
                    position: "top",
                  },
                },
              ]
            }
            this.chart19_data_option.push({option,table,name:ele.ths_moc_project_name})
            return ele
          })
          setTimeout(() => {
            
          });
        }
      }).catch((err)=>{
        console.log(err);
      })
    },
    initstockIntroduce(){
      let codes = this.codes
      stockIntroduce({codes}).then((res)=>{
        this.intro = res.data.intro
      }).catch((err)=>{
        console.log(err);
      })
    },
    initstockBasicData(){
      let codes = this.codes
      stockBasicData({codes}).then((res)=>{

        let data = res.data.real_time_data
        this.information = data
      }).catch((err)=>{
        console.log(err);
      })
    },
    initstockSHNumber(){
      let codes = this.codes
      stockSHNumber({codes}).then((res)=>{
        let data = res.data.chart
        this.chart17_data_x = []
        this.chart17_data_y = []
        this.chart17_data_y2 = []
        data.map((ele)=>{
          this.chart17_data_x.push(ele.InfoPublDate)
          this.chart17_data_y.push(ele.SHNum)
          this.chart17_data_y2.push(ele.ClosePrice)
          return ele
        })
        setTimeout(() => {
          this.$refs.chart17.myEcharts17()
        });
      }).catch((err)=>{
        console.log(err);
      })
    },
    initstockCapitalCost(){
      let codes = ''
      let type
      if(this.bxjj_navigation7 == 0){
        type = 'total_cost'
      }else if(this.bxjj_navigation7 == 1){
        type = 'ths_finance_cost_to_total_revenue_stock'
      }else if(this.bxjj_navigation7 == 2){
        type = 'ths_rad_cost_to_revenue_stock'
      }else if(this.bxjj_navigation7 == 3){
        type = 'ths_manage_fee_to_revenue_2_stock'
      }else if(this.bxjj_navigation7 == 4){
        type = 'ths_sales_fee_to_total_revenue_stock'
      }
      let params = Object.assign({},{codes,type})
      stockCapitalCost(params).then((res)=>{
        let data = res.data.list
        this.chart8_data_x=[]
        this.chart8_data_y=[]
        this.chart8_data_y2=[]
        this.chart8_data_table=[]
        if(this.bxjj_navigation7 == 0){
          data.map((ele)=>{
            this.chart8_data_x.push(ele[0].year)
            this.chart8_data_y2.push(ele[0].total_cost)
            this.chart8_data_y.push(ele[0].contrast_val)
            this.chart8_data_table.push({
              data1:ele[0].year,
              data2:ele[0].total_cost,
              data3:ele[0].contrast_val,
            })
          })
        }else if(this.bxjj_navigation7 == 1){
           data.map((ele)=>{
            this.chart8_data_x.push(ele[0].year)
            this.chart8_data_y2.push(ele[0].ths_finance_cost_to_total_revenue_stock)
            this.chart8_data_y.push(ele[0].contrast_val)
            this.chart8_data_table.push({
              data1:ele[0].year,
              data2:ele[0].ths_finance_cost_to_total_revenue_stock,
              data3:ele[0].contrast_val,
            })
          })
        }else if(this.bxjj_navigation7 == 2){
           data.map((ele)=>{
            this.chart8_data_x.push(ele[0].year)
            this.chart8_data_y2.push(ele[0].ths_rad_cost_to_revenue_stock)
            this.chart8_data_y.push(ele[0].contrast_val)
            this.chart8_data_table.push({
              data1:ele[0].year,
              data2:ele[0].ths_rad_cost_to_revenue_stock,
              data3:ele[0].contrast_val,
            })
          })
        }else if(this.bxjj_navigation7 == 3){
           data.map((ele)=>{
            this.chart8_data_x.push(ele[0].year)
            this.chart8_data_y2.push(ele[0].ths_manage_fee_to_revenue_2_stock)
            this.chart8_data_y.push(ele[0].contrast_val)
            this.chart8_data_table.push({
              data1:ele[0].year,
              data2:ele[0].ths_manage_fee_to_revenue_2_stock,
              data3:ele[0].contrast_val,
            })
          })
        }else if(this.bxjj_navigation7 == 4){
           data.map((ele)=>{
            this.chart8_data_x.push(ele[0].year)
            this.chart8_data_y2.push(ele[0].ths_sales_fee_to_total_revenue_stock)
            this.chart8_data_y.push(ele[0].contrast_val)
            this.chart8_data_table.push({
              data1:ele[0].year,
              data2:ele[0].ths_sales_fee_to_total_revenue_stock,
              data3:ele[0].contrast_val,
            })
          })
        }
        setTimeout(() => {
          this.$refs.chart8.myEcharts8() 
        });
      }).catch((err)=>{
        console.log(err);
      })
    },
    initstockCapitalReturn(){
      let codes = this.codes
      let type
      if(this.bxjj_navigation5 == 0){
        type = 'ths_roe_wgt_publish_stock'
      }else if(this.bxjj_navigation5 == 1){
        type = 'ths_roic_stock'
      }else if(this.bxjj_navigation5 == 2){
        type = 'ths_net_interest_of_ta_stock'
      }
      let params = Object.assign({},{codes,type})
      stockCapitalReturn(params).then((res)=>{
        let data = res.data.list
        this.chart6_data_1 = res.data.latest_val.ths_roe_wgt_publish_stock
        this.chart6_data_2 = res.data.latest_val.ths_roic_stock
        this.chart6_data_3 = res.data.latest_val.ths_net_interest_of_ta_stock
        this.chart6_data_x = []
        this.chart6_data_y = []
        this.chart6_data_y2 = []
        this.chart6_data_table = []
        if(this.bxjj_navigation5 == 0){
          data.map((ele,index)=>{
            this.chart6_data_x.push(ele[0].year)
            this.chart6_data_y2.push(ele[0].ths_roe_wgt_publish_stock)
            this.chart6_data_y.push(ele[0].contrast_val)
            this.chart6_data_table.push({
              data1:ele[0].year,
              data2:ele[0].ths_roe_wgt_publish_stock,
              data3:ele[0].contrast_val,
            })
          })
        }else if(this.bxjj_navigation5 == 1){
          data.map((ele,index)=>{
            this.chart6_data_x.push(ele[0].year)
            this.chart6_data_y2.push(ele[0].ths_roic_stock)
            this.chart6_data_y.push(ele[0].contrast_val)
            this.chart6_data_table.push({
              data1:ele[0].year,
              data2:ele[0].ths_roic_stock,
              data3:ele[0].contrast_val,
            })
          })
        }else if(this.bxjj_navigation5 == 2){
          data.map((ele,index)=>{
            this.chart6_data_x.push(ele[0].year)
            this.chart6_data_y2.push(ele[0].ths_net_interest_of_ta_stock)
            this.chart6_data_y.push(ele[0].contrast_val)
            this.chart6_data_table.push({
              data1:ele[0].year,
              data2:ele[0].ths_net_interest_of_ta_stock,
              data3:ele[0].contrast_val,
            })
          })
        }
        setTimeout(() => {
         this.$refs.chart6.myEcharts6() 
        });
      }).catch((err)=>{
        console.log(err);
      })
    },
    initstockDupontAnalysis(){
      stockDupontAnalysis().then((res)=>{
        this.chart5_data_y.push(res.data.own.ths_dupont_total_capital_turnover_stock)
        this.chart5_data_y2.push(res.data.contrast.ths_dupont_total_capital_turnover_stock)

        this.chart5_data_y.push(res.data.own.ths_equity_multiplier_stock)
        this.chart5_data_y2.push(res.data.contrast.ths_equity_multiplier_stock)

        this.chart5_data_y.push(res.data.own.ths_net_sales_rate_stock)
        this.chart5_data_y2.push(res.data.contrast.ths_net_sales_rate_stock)

        this.chart5_data_y.push(res.data.own.ths_roe_wgt_publish_stock)
        this.chart5_data_y2.push(res.data.contrast.ths_roe_wgt_publish_stock)
        setTimeout(() => {
         this.$refs.chart5.init() 
        });
      }).catch((err)=>{
        console.log(err);
      })
    },
    initstockProfitMargin(){
      let codes = this.codes
      let contrast_codes = ''
      let type
      if(this.bxjj_navigation6 == 0){
        type = 'ths_gross_selling_rate_stock'
      }else if(this.bxjj_navigation6 == 1){
        type = 'ths_net_sales_rate_stock'
      }else if(this.bxjj_navigation6 == 2){
        type = 'ths_op_to_revenue_stock'
      }
      let params = Object.assign({},{codes,type})
      stockProfitMargin(params).then((res)=>{
        let data = res.data.list
        this.chart7_data_1 = res.data.latest_val.ths_gross_selling_rate_stock
        this.chart7_data_2 = res.data.latest_val.ths_net_sales_rate_stock
        this.chart7_data_3 = res.data.latest_val.ths_op_to_revenue_stock
        this.chart7_data_x = []
        this.chart7_data_y = []
        this.chart7_data_y2 = []
        this.chart7_data_table = []
      if(this.bxjj_navigation6 == 0){
        data.map((ele,index)=>{
          this.chart7_data_x.push(ele[0].year)
          this.chart7_data_y2.push(ele[0].ths_gross_selling_rate_stock)
          this.chart7_data_y.push(ele[0].contrast_val)
          this.chart7_data_table.push({
            data1:ele[0].year,
            data2:ele[0].ths_gross_selling_rate_stock,
            data3:ele[0].contrast_val,
          })
        })
      }else if(this.bxjj_navigation6 == 1){
        data.map((ele,index)=>{
          this.chart7_data_x.push(ele[0].year)
          this.chart7_data_y2.push(ele[0].ths_net_sales_rate_stock)
          this.chart7_data_y.push(ele[0].contrast_val)
          this.chart7_data_table.push({
            data1:ele[0].year,
            data2:ele[0].ths_net_sales_rate_stock,
            data3:ele[0].contrast_val,
          })
        })
      }else if(this.bxjj_navigation6 == 2){
      data.map((ele,index)=>{
          this.chart7_data_x.push(ele[0].year)
          this.chart7_data_y2.push(ele[0].ths_op_to_revenue_stock)
          this.chart7_data_y.push(ele[0].contrast_val)
          this.chart7_data_table.push({
            data1:ele[0].year,
            data2:ele[0].ths_op_to_revenue_stock,
            data3:ele[0].contrast_val,
          })
        })
      }
      setTimeout(() => {
        this.$refs.chart7.myEcharts7() 
      });
      }).catch((err)=>{
        console.log(err);
      })
    },
    initstockGrowthAbility(){
      let codes = this.codes
      let time_len =this.chart4_option
      let type 
      if(this.bxjj_navigation4 == 0){
        type = 'ths_operating_total_revenue_stock'
      }else if(this.bxjj_navigation4 == 1){
        type = 'ths_np_atoopc_stock'
      }else if(this.bxjj_navigation4 == 2){
        type = 'ths_np_dnrgal_stock'
      }else{
        this.$message.error('!!!')
        return
      }
      stockGrowthAbility({codes,time_len,type}).then((res)=>{
        let data = res.data.list

        this.chart4_data_x=[];
        this.chart4_data_y=[];
        this.chart4_data_y2=[];
        this.chart4_data_y3=[];
        this.chart4_data_y4=[];
        this.chart4_data_table=[];
        this.chart42_data_x = [];
        this.chart42_data_y = [];
        this.chart42_data_y2 = [];
        this.chart42_data_table = [];
        if(this.chart4_option == 1){
          if(this.bxjj_navigation4 == 0){
            data.map((ele,index)=>{
              this.chart4_data_x.push(ele[0].year)
              this.chart4_data_y.push(ele[0].ths_operating_total_revenue_stock)
              this.chart4_data_y2.push(ele[1].ths_operating_total_revenue_stock)
              this.chart4_data_y3.push(ele[2].ths_operating_total_revenue_stock)
              this.chart4_data_y4.push(ele[3].ths_operating_total_revenue_stock)
              this.chart4_data_table.push({
                data1:ele[0].year,
                data2:ele[0].ths_operating_total_revenue_stock,
                data3:ele[1].ths_operating_total_revenue_stock,
                data4:ele[2].ths_operating_total_revenue_stock,
                data5:ele[3].ths_operating_total_revenue_stock,
              })
            })
          }else if(this.bxjj_navigation4 == 1){
            data.map((ele,index)=>{
              this.chart4_data_x.push(ele[0].year)
              this.chart4_data_y.push(ele[0].ths_np_atoopc_stock)
              this.chart4_data_y2.push(ele[1].ths_np_atoopc_stock)
              this.chart4_data_y3.push(ele[2].ths_np_atoopc_stock)
              this.chart4_data_y4.push(ele[3].ths_np_atoopc_stock)
              this.chart4_data_table.push({
                data1:ele[0].year,
                data2:ele[0].ths_np_atoopc_stock,
                data3:ele[1].ths_np_atoopc_stock,
                data4:ele[2].ths_np_atoopc_stock,
                data5:ele[3].ths_np_atoopc_stock,
              })
            })
          }else if(this.bxjj_navigation4 == 2){
            data.map((ele,index)=>{
              this.chart4_data_x.push(ele[0].year)
              this.chart4_data_y.push(ele[0].ths_np_dnrgal_stock)
              this.chart4_data_y2.push(ele[1].ths_np_dnrgal_stock)
              this.chart4_data_y3.push(ele[2].ths_np_dnrgal_stock)
              this.chart4_data_y4.push(ele[3].ths_np_dnrgal_stock)
              this.chart4_data_table.push({
                data1:ele[0].year,
                data2:ele[0].ths_np_dnrgal_stock,
                data3:ele[1].ths_np_dnrgal_stock,
                data4:ele[2].ths_np_dnrgal_stock,
                data5:ele[3].ths_np_dnrgal_stock,
              })
            })
          }
        }else if(this.chart4_option == 2){
          if(this.bxjj_navigation4 == 0){
            data.map((ele,index)=>{
              this.chart42_data_x.push(ele[0].year)
              this.chart42_data_y.push(ele[0].ths_operating_total_revenue_stock)
              this.chart42_data_y2.push(ele[0].growth_rate)
              this.chart42_data_table.push({
                data1:ele[0].year,
                data2:ele[0].ths_operating_total_revenue_stock,
                data3:ele[0].growth_rate,
              })
            })
          }else if(this.bxjj_navigation4 == 1){
            data.map((ele,index)=>{
              this.chart42_data_x.push(ele[0].year)
              this.chart42_data_y.push(ele[0].ths_np_atoopc_stock)
              this.chart42_data_y2.push(ele[0].growth_rate)
              this.chart42_data_table.push({
                data1:ele[0].year,
                data2:ele[0].ths_np_atoopc_stock,
                data3:ele[0].growth_rate,
              })
            })
          }else if(this.bxjj_navigation4 == 2){
            data.map((ele,index)=>{
              this.chart42_data_x.push(ele[0].year)
              this.chart42_data_y.push(ele[0].ths_np_dnrgal_stock)
              this.chart42_data_y2.push(ele[0].growth_rate)
              this.chart42_data_table.push({
                data1:ele[0].year,
                data2:ele[0].ths_np_dnrgal_stock,
                data3:ele[0].growth_rate,
              })
            })
          }
        }
        // return
        this.chart4_data_table = this.chart4_data_table.map((ele)=>{
          if(ele.data2 == null){
            ele.data2 = null
          }else if((ele.data2 < 1000000000 && ele.data2 > 100000000) || (ele.data2 > -1000000000 && ele.data2 <= -100000000)){
            ele.data2 = (Number(ele.data2 / 100000000).toFixed(2)) + '亿'
          }else if((ele.data2 >= 1000000000 && ele.data2 < 10000000000) || (ele.data2 <= -1000000000 && ele.data2 > -10000000000)){
            ele.data2 = (Number(ele.data2 / 100000000).toFixed(1)) + '亿'
          }else if(ele.data2 >= 10000000000 || ele.data2 <= -10000000000){
            ele.data2 = (Number(ele.data2 / 100000000).toFixed(0)) + '亿'
          }else{
            ele.data2 = (Number(ele.data2 / 10000).toFixed(0)) + '万'
          }
          if(ele.data3 == null){
            ele.data3 = null
          }else if((ele.data3 < 1000000000 && ele.data3 > 100000000) || (ele.data3 > -1000000000 && ele.data3 <= -100000000)){
            ele.data3 = (Number(ele.data3 / 100000000).toFixed(2)) + '亿'
          }else if((ele.data3 >= 1000000000 && ele.data3 < 10000000000) || (ele.data3 <= -1000000000 && ele.data3 > -10000000000)){
            ele.data3 = (Number(ele.data3 / 100000000).toFixed(1)) + '亿'
          }else if(ele.data3 >= 10000000000 || ele.data3 <= -10000000000){
            ele.data3 = (Number(ele.data3 / 100000000).toFixed(0)) + '亿'
          }else{
            ele.data3 = (Number(ele.data3 / 10000).toFixed(0)) + '万'
          }
          if(ele.data4){
            if(ele.data4 == null){
              ele.data4 = null
            }else if((ele.data4 < 1000000000 && ele.data4 > 100000000) || (ele.data4 > -1000000000 && ele.data4 <= -100000000)){
              ele.data4 = (Number(ele.data4 / 100000000).toFixed(2)) + '亿'
            }else if((ele.data4 >= 1000000000 && ele.data4 < 10000000000) || (ele.data4 <= -1000000000 && ele.data4 > -10000000000)){
              ele.data4 = (Number(ele.data4 / 100000000).toFixed(1)) + '亿'
            }else if(ele.data4 >= 10000000000 || ele.data4 <= -10000000000){
              ele.data4 = (Number(ele.data4 / 100000000).toFixed(0)) + '亿'
            }else{
              ele.data4 = (Number(ele.data4 / 10000).toFixed(0)) + '万'
            }
          }
          if(ele.data5){
            if(ele.data5 == null){
              ele.data5 = null
            }else if((ele.data5 < 1000000000 && ele.data5 > 100000000) || (ele.data5 > -1000000000 && ele.data5 <= -100000000)){
              ele.data5 = (Number(ele.data5 / 100000000).toFixed(2)) + '亿'
            }else if((ele.data5 >= 1000000000 && ele.data5 < 10000000000) || (ele.data5 <= -1000000000 && ele.data5 > -10000000000)){
              ele.data5 = (Number(ele.data5 / 100000000).toFixed(1)) + '亿'
            }else if(ele.data5 >= 10000000000 || ele.data5 <= -10000000000){
              ele.data5 = (Number(ele.data5 / 100000000).toFixed(0)) + '亿'
            }else{
              ele.data5 = (Number(ele.data5 / 10000).toFixed(0)) + '万'
            }
          }
          return ele

        })
        this.chart42_data_table = this.chart42_data_table.map((ele)=>{
          if(ele.data2 == null){
            ele.data2 = null
          }else if((ele.data2 < 1000000000 && ele.data2 > 100000000) || (ele.data2 > -1000000000 && ele.data2 <= -100000000)){
            ele.data2 = (Number(ele.data2 / 100000000).toFixed(2)) + '亿'
          }else if((ele.data2 >= 1000000000 && ele.data2 < 10000000000) || (ele.data2 <= -1000000000 && ele.data2 > -10000000000)){
            ele.data2 = (Number(ele.data2 / 100000000).toFixed(1)) + '亿'
          }else if(ele.data2 >= 10000000000 || ele.data2 <= -10000000000){
            ele.data2 = (Number(ele.data2 / 100000000).toFixed(0)) + '亿'
          }else{
            ele.data2 = (Number(ele.data2 / 10000).toFixed(0)) + '万'
          }
          return ele
        })
        this.chart4_data_1 = res.data.latest_val.ths_operating_total_revenue_stock
        this.chart4_data_2 = res.data.latest_val.ths_np_atoopc_stock
        this.chart4_data_3 = res.data.latest_val.ths_np_dnrgal_stock
        if(this.chart4_data_1 == null){
          this.chart4_data_1 = null
        }else if((this.chart4_data_1 < 1000000000 && this.chart4_data_1 > 100000000) || (this.chart4_data_1 > -1000000000 && this.chart4_data_1 <= -100000000)){
          this.chart4_data_1 = (Number(this.chart4_data_1 / 100000000).toFixed(2)) + '亿'
        }else if((this.chart4_data_1 >= 1000000000 && this.chart4_data_1 < 10000000000) || (this.chart4_data_1 <= -1000000000 && this.chart4_data_1 > -10000000000)){
          this.chart4_data_1 = (Number(this.chart4_data_1 / 100000000).toFixed(1)) + '亿'
        }else if(this.chart4_data_1 >= 10000000000 || this.chart4_data_1 <= -10000000000){
          this.chart4_data_1 = (Number(this.chart4_data_1 / 100000000).toFixed(0)) + '亿'
        }else{
          this.chart4_data_1 = (Number(this.chart4_data_1 / 10000).toFixed(0)) + '万'
        }
        if(this.chart4_data_2 == null){
          this.chart4_data_2 = null
        }else if((this.chart4_data_2 < 1000000000 && this.chart4_data_2 > 100000000) || (this.chart4_data_2 > -1000000000 && this.chart4_data_2 <= -100000000)){
          this.chart4_data_2 = (Number(this.chart4_data_2 / 100000000).toFixed(2)) + '亿'
        }else if((this.chart4_data_2 >= 1000000000 && this.chart4_data_2 < 10000000000) || (this.chart4_data_2 <= -1000000000 && this.chart4_data_2 > -10000000000)){
          this.chart4_data_2 = (Number(this.chart4_data_2 / 100000000).toFixed(1)) + '亿'
        }else if(this.chart4_data_2 >= 10000000000 || this.chart4_data_2 <= -10000000000){
          this.chart4_data_2 = (Number(this.chart4_data_2 / 100000000).toFixed(0)) + '亿'
        }else{
          this.chart4_data_2 = (Number(this.chart4_data_2 / 10000).toFixed(0)) + '万'
        }
        if(this.chart4_data_3 == null){
          this.chart4_data_3 = null
        }else if((this.chart4_data_3 < 1000000000 && this.chart4_data_3 > 100000000) || (this.chart4_data_3 > -1000000000 && this.chart4_data_3 <= -100000000)){
          this.chart4_data_3 = (Number(this.chart4_data_3 / 100000000).toFixed(2)) + '亿'
        }else if((this.chart4_data_3 >= 1000000000 && this.chart4_data_3 < 10000000000) || (this.chart4_data_3 <= -1000000000 && this.chart4_data_3 > -10000000000)){
          this.chart4_data_3 = (Number(this.chart4_data_3 / 100000000).toFixed(1)) + '亿'
        }else if(this.chart4_data_3 >= 10000000000 || this.chart4_data_3 <= -10000000000){
          this.chart4_data_3 = (Number(this.chart4_data_3 / 100000000).toFixed(0)) + '亿'
        }else{
          this.chart4_data_3 = (Number(this.chart4_data_3 / 10000).toFixed(0)) + '万'
        }
        setTimeout(() => {
          if(this.chart4_option == 1){
            this.$refs.chart4.myEcharts4()
          }else{
            this.$refs.chart42.myEcharts42()
          }
          
          
        });
      }).catch((err)=>{
        console.log(err);
      })
    },
    chart2_option_open(){
      this.chart2_option_show = true
    },
    chart4_option_open(){
      this.chart4_option_show = true
    },
    changeoption(e){
      this.chart2_option = e
      this.chart2_option_show = false
      this.initstockValuation()
    },
    changeoption4(e){
      this.chart4_option = e
      this.chart4_option_show = false
      this.initstockGrowthAbility()
    },
    initstockValuation(){
      let codes = '002821.SZ'
      let time_len 
      if(this.chart2_option == 1){
        time_len = '3'
      }else if(this.chart2_option == 2){
        time_len = '5'
      }else if(this.chart2_option == 3){
        time_len = '10'
      }
      let type 
      if(this.bxjj_navigation2 == 0){
        type = 'ths_auto_pe_csi_stock'
      }else if(this.bxjj_navigation2 == 1){
        type = 'ths_pb_latest_stock'
      }else if(this.bxjj_navigation2 == 2){
        type = 'ths_ps_ttm_stock'
      }else if(this.bxjj_navigation2 == 3){
        type = 'ths_pcf_operating_cash_flow_ttm_stock'
      }else{
        this.$message.error('!!!')
        return
      }
      let params = Object.assign({},{codes,type,time_len})
      stockValuation(params).then((res)=>{
        let data = res.data.list
        this.chart2_data_1 = res.data.latest_val.ths_auto_pe_csi_stock
        this.chart2_data_2 = res.data.latest_val.ths_pb_latest_stock
        this.chart2_data_3 = res.data.latest_val.ths_ps_ttm_stock
        this.chart2_data_4 = res.data.latest_val.ths_pcf_operating_cash_flow_ttm_stock
        this.chart2_data_txt = res.data.txt
        this.chart2_data_x = []
        this.chart2_data_y = []
        this.chart2_data_y2 = []
        this.chart2_data_y3 = []
        this.chart2_data_y4 = []
        data.map((ele)=>{
          this.chart2_data_x.push(ele.update_time)
          if(this.bxjj_navigation2 == 0){
            this.chart2_data_y.push(ele.ths_auto_pe_csi_stock)
          }else if(this.bxjj_navigation2 == 1){
            this.chart2_data_y.push(ele.ths_pb_latest_stock)
          }else if(this.bxjj_navigation2 == 2){
            this.chart2_data_y.push(ele.ths_ps_ttm_stock)
          }else if(this.bxjj_navigation2 == 3){
            this.chart2_data_y.push(ele.ths_pcf_operating_cash_flow_ttm_stock)
          }
          this.chart2_data_y2.push(ele.min)
          this.chart2_data_y3.push(ele.center)
          this.chart2_data_y4.push(ele.max)
          return ele
        })
        setTimeout(() => {
         this.$refs.chart2.myEcharts2() 
        });
      }).catch((err)=>{
        console.log(err);
      })
    },
    close_prame1() {
      this.frame1_show = false;
    },
    frame2_close() {
      this.frame2_show = false;
    },
    frame2_open() {
      this.frame2_show = true;
    },
    frame1_open() {
      this.frame1_show = true;
    },
    frame9_close() {
      this.frame9_show = false;
    },
    frame8_close() {
      this.frame8_show = false;
    },
    frame10_open() {
      this.frame10_show = true;
    },
    frame10_close() {
      this.frame10_show = false;
    },
    frame11_open() {
      this.frame11_show = true;
    },
    frame11_close() {
      this.frame11_show = false;
    },
    frame12_open() {
      this.frame12_show = true;
    },
    frame12_close() {
      this.frame12_show = false;
    },
    frame13_open() {
      this.frame13_show = true;
    },
    frame13_close() {
      this.frame13_show = false;
    },
    frame14_open() {
      this.frame14_show = true;
    },
    frame14_close() {
      this.frame14_show = false;
    },
    frame15_open() {
      this.frame15_show = true;
    },
    frame15_close() {
      this.frame15_show = false;
    },
    frame16_open() {
      this.frame16_show = true;
    },
    frame16_close() {
      this.frame16_show = false;
    },
    frame17_open() {
      this.frame17_show = true;
    },
    frame17_close() {
      this.frame17_show = false;
    },
    frame18_open() {
      this.frame18_show = true;
    },
    frame18_close() {
      this.frame18_show = false;
    },
    frame19_open() {
      this.frame19_show = true;
    },
    frame19_close() {
      this.frame19_show = false;
    },
    frame20_open() {
      this.frame20_show = true;
    },
    frame20_close() {
      this.frame20_show = false;
    },
    frame21_open() {
      this.frame21_show = true;
    },
    frame21_close() {
      this.frame21_show = false;
    },
    change_change_option(e) {
      this.change_option = e;
    },
    change_top_button(e) {
      this.bxjj_navigation = e;
    },
    change_top_button2(e) {
      this.bxjj_navigation2 = e;
      this.initstockValuation()
    },
    change_top_button3(e) {
      this.bxjj_navigation3 = e;
      this.initstockPePbBand()
    },
    change_top_button4(e) {
      this.bxjj_navigation4 = e;
      this.initstockGrowthAbility()
    },
    change_top_button5(e) {
      this.bxjj_navigation5 = e;
      this.initstockCapitalReturn()
    },
    change_top_button6(e) {
      this.bxjj_navigation6 = e;
      this.initstockProfitMargin()
    },
    change_top_button7(e) {
      this.bxjj_navigation7 = e;
      this.initstockCapitalCost()
    },
    change_top_button8(e) {
      this.bxjj_navigation8 = e;
    },
    change_top_button9(e) {
      this.bxjj_navigation9 = e;
      this.initstockMainBusiness()
    },
    change_top_button10(e) {
      this.bxjj_navigation10 = e;
    },
    ckqw(e) {
      console.log(e);
    },
  },
  components: {
    Chart1,
    Chart2,
    Chart3,
    Chart4,
    Chart42,
    Chart5,
    Chart6,
    Chart7,
    Chart8,
    Chart9,
    Chart10,
    Chart11,
    Chart12,
    Chart13,
    Chart14,
    Chart15,
    Chart16,
    Chart17,
    Chart18,
    Chart19,
    // Chart20,
    // Chart21,
    Frame1,
    Frame2,
    Frame3,
    Frame4,
    Frame5,
    Frame6,
    Frame7,
    Frame8,
    Frame9,
    Frame10,
    Frame11,
    Frame12,
    Frame13,
    Frame14,
    Frame15,
    Frame16,
    Frame17,
    Frame18,
    Frame19,
    Frame20,
    Frame21,
  },
};
</script>

<style scoped>
i{
  font-style: normal;
}
.shares_Info {
  margin-bottom: 50px;
}
.box1 {
  width: calc(100% - 48px);
  height: 109px;
  padding: 35px 24px;
  border-radius: 3px;
  background-color: #fff;
  display: flex;
}
.box2 {
  width: calc(100% - 48px);
  height: 390px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
}
.box3 {
  width: calc(100% - 48px);
  /* height: 82px; */
  padding: 0px 24px;
  border-radius: 3px;
  background-color: #fff;
  overflow: hidden;
  margin-top: 24px;
}
.box3_top {
  display: flex;
  justify-content: space-between;
}
.box3_text1 {
  font-size: 18px;
  line-height: 82px;
  color: #333333;
  font-weight: bold;
}
.box3_text1 img {
  width: 48px;
  /* height: 19px; */
  vertical-align: middle;
  margin-left: 10px;
}
.box3_text2 {
  font-size: 16px;
  line-height: 82px;
  color: #666666;
  cursor: pointer;
}
.box3_text2 img {
  width: 17px;
  /* height: 19px; */
  vertical-align: middle;
  margin-left: 5px;
}

.box4 {
  width: calc(100% - 48px);
  /* height: 82px; */
  padding: 0px 24px;
  border-radius: 3px;
  background-color: #fff;
  overflow: hidden;
  margin-top: 24px;
}
.box4_top {
  display: flex;
  justify-content: space-between;
}
.box4_text1 {
  font-size: 18px;
  line-height: 82px;
  color: #333333;
  font-weight: bold;
}
.box4_text1 img {
  width: 48px;
  /* height: 19px; */
  vertical-align: middle;
  margin-left: 10px;
}
.box4_text2 {
  font-size: 16px;
  line-height: 82px;
  color: #666666;
  cursor: pointer;
}
.box4_text2 img {
  width: 17px;
  /* height: 19px; */
  vertical-align: middle;
  margin-left: 5px;
}

.box5 {
  width: calc(100% - 48px);
  /* height: 417px; */
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box6 {
  width: calc(100% - 48px);
  height: 480px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box7 {
  width: calc(100% - 48px);
  height: 480px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box8 {
  width: calc(100% - 48px);
  /* height: 615px; */
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box9 {
  width: calc(100% - 48px);
  height: 355px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box10 {
  width: calc(100% - 48px);
  height: 500px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box11 {
  width: calc(100% - 48px);
  height: 500px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box12 {
  width: calc(100% - 48px);
  height: 500px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box13 {
  width: calc(100% - 48px);
  height: 800px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box14 {
  width: calc(100% - 48px);
  height: 560px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box15 {
  width: calc(100% - 48px);
  /* height: 378px; */
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box16 {
  width: calc(100% - 48px);
  height: 500px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box17 {
  width: calc(100% - 48px);
  height: 355px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box18 {
  width: calc(100% - 48px);
  height: 355px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box19 {
  width: calc(100% - 48px);
  height: 466px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box20 {
  width: calc(100% - 48px);
  height: 370px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box21 {
  width: calc(100% - 48px);
  height: 406px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box22 {
  width: calc(100% - 48px);
  height: 406px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box23 {
  width: calc(100% - 48px);
  height: 180px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box24 {
  width: calc(100% - 48px);
  height: 320px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box25 {
  width: calc(100% - 48px);
  height: 320px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box1_left {
  display: flex;
  flex-direction: column;
}
.box1_left_top {
  display: flex;
  align-content: center;
  line-height: 24px;
}
.box1_left_top_text1 {
  font-size: 24px;
  font-weight: bold;
  color: #000000;
}
.box1_left_top_text2 {
  font-size: 18px;
  color: #000000;
  margin-left: 10px;
}
.box1_left_top_text3 {
  width: 64px;
  height: 20px;
  line-height: 20px;
  margin-top: 3px;
  text-align: center;
  background-color: #fcad2a;
  border-radius: 3px;
  font-size: 12px;
  color: #ffffff;
  margin-left: 18px;
}
.box1_left_top_text4 {
  width: 54px;
  height: 20px;
  line-height: 20px;
  margin-top: 3px;
  text-align: center;
  background-color: #fcad2a;
  border-radius: 3px;
  font-size: 12px;
  color: #ffffff;
  margin-left: 18px;
}
.box1_left_top_text5 {
  font-size: 12px;
  margin-left: 20px;
  color: #000000;
}
.box1_left_bottom {
  display: flex;
  margin-top: 18px;
}
.box1_left_bottom_left {
  display: flex;
  flex-direction: column;
  padding-right: 24px;
  border-right: 1px solid #ebebeb;
}
.box1_left_bottom_left_text1 {
  font-size: 30px;
  /* color: #fd4c4c; */
}
.box1_left_bottom_left_text2 {
  /* color: #fd4c4c; */
  font-size: 18px;

  color: #fd4c4c;
}
.box1_left_bottom_right {
  margin-left: 30px;
  display: flex;
}
.box1_left_bottom_right_group1 {
  font-size: 14px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-right: 15px;
  color: #333;
}
.box1_right {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  padding-left: 60px;
}
.box1_right_top {
  width: 176px;
  height: 30px;
  background-color: #fcad2a;
  border-radius: 6px;
  font-size: 12px;
  text-align: center;
  line-height: 30px;
  color: #ffffff;
  cursor: pointer;
}
.box1_right_bottom {
  display: flex;
  margin-top: 12px;
}
.box1_right_bottom_left {
  width: 84px;
  height: 30px;
  border-radius: 6px;
  border: solid 1px #fcad2a;
  font-size: 12px;
  text-align: center;
  line-height: 30px;
  color: #fcad2a;
  cursor: pointer;
}
.box1_right_bottom_right {
  width: 84px;
  height: 30px;
  border-radius: 6px;
  border: solid 1px #fcad2a;
  font-size: 12px;
  text-align: center;
  line-height: 30px;
  color: #fcad2a;
  margin-left: 6px;
  cursor: pointer;
}
.box2_top_button {
  height: 24px;
  display: flex;
  margin-bottom: 25px;
}
.box2_top_button_text1 {
  font-size: 18px;
  color: #666666;
  cursor: pointer;
  margin-left: 24px;
}
.box2_top_button_text1:nth-child(1) {
  margin-left: 0px;
}
.box2_top_button_text2 {
  color: #000000;
  font-weight: bold;
  position: relative;
}
.box2_top_button_text2::after {
  content: " ";
  display: block;
  width: 36px;
  height: 3px;
  background: #fcad2a;
  border-radius: 3px;
  overflow: hidden;
  margin: 0 auto;
  position: absolute;
  bottom: -6px;
  left: calc(50% - 18px);
}
.box5_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
}
.box5_top_button {
  display: flex;
  align-content: center;
  margin-top: 20px;
  margin-bottom: 25px;
}
.box5_top_button_button1 {
  padding: 6px 10px;
  text-align: center;
  font-size: 14px;
  color: #333333;
  border-radius: 6px;
  margin-left: 12px;
  background-color: #f8f8f8;
  cursor: pointer;
}
.box5_top_button_button1:nth-child(1) {
  margin-left: 0;
}
.box5_top_button_button2 {
  background-color: #fcad2a;
  color: #fff;
}
.box5_table_centent_text1 {
  font-size: 16px;
  color: #333333;
}
.box5_table_centent_text2 {
  font-size: 14px;
  color: #666666;
}
.box5_table_cz {
  text-align: center;
  color: #fcad2a;
  cursor: pointer;
}
.box5_bottom {
  width: 100%;
  font-size: 16px;
  color: #333333;
  /* position: absolute; */
  margin: 0 auto;
  text-align: center;
  margin-top: 20px;
}
.box5_bottom img {
  width: 14px;
  margin-left: 5px;
}

.el-table /deep/ th {
  background-color: #f8f9fd !important;
  text-align: center;
  height: 56px;
}
.el-table /deep/ td {
  height: 72px;
}

.box6_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}
.box6_top_button {
  display: flex;
  align-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.box6_top_button_button1 {
  padding: 6px 10px;
  text-align: center;
  font-size: 14px;
  color: #333333;
  border-radius: 6px;
  margin-left: 12px;
  background-color: #f8f8f8;
  cursor: pointer;
}
.box6_top_button_button1:nth-child(1) {
  margin-left: 0;
}
.box6_top_button_button2 {
  background-color: #fcad2a;
  color: #fff;
}
.box6_top_tip {
  font-size: 14px;
  color: #333333;
}

.box6_top_legend_box {
  display: flex;
  margin-top: 20px;
}
.box6_top_legend_box_option1 {
  display: flex;
  align-content: center;
  font-size: 14px;
  line-height: 15px;
  color: #333333;
  margin-left: 15px;
  cursor: pointer;
}
.box6_top_legend_box_option1:nth-child(1) {
  margin-left: 0;
}
.box6_top_legend_box_option1_colordiv {
  background-color: #fd4c4c;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box6_top_legend_box_option2_colordiv {
  background-color: #fcad2a;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box6_top_legend_box_option3_colordiv {
  background-color: #3cbb73;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}

.box7_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}
.box7_top_title_text1 {
}
.box7_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  /* opacity: 0.06; */
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
  position: relative;
}
.box7_top_title_option{
  position: absolute;
  width: 54px;
  padding: 0 15px;
  text-align: center;
  top: 24px;
  left: 0;
  background-color: #ffffff;
}
.box7_top_button {
  display: flex;
  align-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.box7_top_button_button1 {
  padding: 6px 10px;
  text-align: center;
  font-size: 14px;
  color: #333333;
  border-radius: 6px;
  margin-left: 12px;
  background-color: #f8f8f8;
  cursor: pointer;
}
.box7_top_button_button1:nth-child(1) {
  margin-left: 0;
}
.box7_top_button_button2 {
  background-color: #fcad2a;
  color: #fff;
}
.box7_top_tip {
  font-size: 14px;
  color: #333333;
}
.box7_top_legend_box {
  display: flex;
  margin-top: 20px;
}
.box7_top_legend_box_option1 {
  display: flex;
  align-content: center;
  font-size: 14px;
  line-height: 15px;
  color: #333333;
  margin-left: 15px;
  cursor: pointer;
}
.box7_top_legend_box_option1:nth-child(1) {
  margin-left: 0;
}
.box7_top_legend_box_option1_colordiv {
  background-color: #fd4c4c;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box7_top_legend_box_option2_colordiv {
  background-color: #fcad2a;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box7_top_legend_box_option3_colordiv {
  background-color: #3cbb73;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box7_top_legend_box_option4_colordiv {
  background-color: #7a7ef3;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box7_top_legend_box_option5_colordiv {
  background-color: #fff191;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box7_top_legend_box_option6_colordiv {
  background-color: #aae5a1;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}

.box8_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}
.box8_top_title_text1 {
}
.box8_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  /* opacity: 0.06; */
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
  position: relative;
}
.box8_top_title_option{
  position: absolute;
  width: 54px;
  padding: 0 15px;
  text-align: center;
  top: 24px;
  left: 0;
  background-color: #ffffff;
}
.box8_top_button {
  display: flex;
  align-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.box8_top_button_button1 {
  padding: 6px 10px;
  text-align: center;
  font-size: 14px;
  color: #333333;
  border-radius: 6px;
  margin-left: 12px;
  background-color: #f8f8f8;
  cursor: pointer;
}
.box8_top_button_button1:nth-child(1) {
  margin-left: 0;
}
.box8_top_button_button2 {
  background-color: #fcad2a;
  color: #fff;
}
.box8_top_tip {
  font-size: 14px;
  color: #333333;
}
.box8_top_legend_box {
  display: flex;
  margin-top: 20px;
}
.box8_top_legend_box_option1 {
  display: flex;
  align-content: center;
  font-size: 14px;
  line-height: 15px;
  color: #333333;
  margin-left: 15px;
  cursor: pointer;
}
.box8_top_legend_box_option1:nth-child(1) {
  margin-left: 0;
}
.box8_top_legend_box_option1_colordiv {
  background-color: rgba(252, 173, 42, 0.4);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box8_top_legend_box_option2_colordiv {
  background-color: rgba(252, 173, 42, 0.6);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box8_top_legend_box_option3_colordiv {
  background-color: rgba(252, 173, 42, 0.8);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box8_top_legend_box_option4_colordiv {
  background-color: rgba(252, 173, 42, 1);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box8_top_legend_box_option5_colordiv {
  background-color: #579eff;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}

.box9_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}
.box9_top_title_text1 {
}
.box9_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
}
.box9_top_legend_box {
  display: flex;
  margin-top: 20px;
}
.box9_top_legend_box_option1 {
  display: flex;
  align-content: center;
  font-size: 14px;
  line-height: 15px;
  color: #333333;
  margin-left: 15px;
  cursor: pointer;
}
.box9_top_legend_box_option1:nth-child(1) {
  margin-left: 0;
}
.box9_top_legend_box_option1_colordiv {
  background-color: #539cff;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box9_top_legend_box_option2_colordiv {
  background-color: rgba(252, 173, 42, 1);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}

.box10_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}
.box10_top_title_text1 {
}
.box10_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  /* opacity: 0.06; */
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
}
.box10_top_button {
  display: flex;
  align-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.box10_top_button_button1 {
  padding: 6px 10px;
  text-align: center;
  font-size: 14px;
  color: #333333;
  border-radius: 6px;
  margin-left: 12px;
  background-color: #f8f8f8;
  cursor: pointer;
}
.box10_top_button_button1:nth-child(1) {
  margin-left: 0;
}
.box10_top_button_button2 {
  background-color: #fcad2a;
  color: #fff;
}
.box10_top_tip {
  font-size: 14px;
  color: #333333;
}
.box10_top_legend_box {
  display: flex;
  margin-top: 20px;
}
.box10_top_legend_box_option1 {
  display: flex;
  align-content: center;
  font-size: 14px;
  line-height: 15px;
  color: #333333;
  margin-left: 15px;
  cursor: pointer;
}
.box10_top_legend_box_option1:nth-child(1) {
  margin-left: 0;
}
.box10_top_legend_box_option1_colordiv {
  background-color: #539cff;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box10_top_legend_box_option2_colordiv {
  background-color: #fcad2a;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}

.box11_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}
.box11_top_title_text1 {
}
.box11_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  /* opacity: 0.06; */
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
}
.box11_top_button {
  display: flex;
  align-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.box11_top_button_button1 {
  padding: 6px 10px;
  text-align: center;
  font-size: 14px;
  color: #333333;
  border-radius: 6px;
  margin-left: 12px;
  background-color: #f8f8f8;
  cursor: pointer;
}
.box11_top_button_button1:nth-child(1) {
  margin-left: 0;
}
.box11_top_button_button2 {
  background-color: #fcad2a;
  color: #fff;
}
.box11_top_tip {
  font-size: 14px;
  color: #333333;
}
.box11_top_legend_box {
  display: flex;
  margin-top: 20px;
}
.box11_top_legend_box_option1 {
  display: flex;
  align-content: center;
  font-size: 14px;
  line-height: 15px;
  color: #333333;
  margin-left: 15px;
  cursor: pointer;
}
.box11_top_legend_box_option1:nth-child(1) {
  margin-left: 0;
}
.box11_top_legend_box_option1_colordiv {
  background-color: #539cff;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box11_top_legend_box_option2_colordiv {
  background-color: #fcad2a;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}

.box12_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}
.box12_top_title_text1 {
}
.box12_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  /* opacity: 0.06; */
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
}
.box12_top_button {
  display: flex;
  align-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.box12_top_button_button1 {
  padding: 6px 10px;
  text-align: center;
  font-size: 14px;
  color: #333333;
  border-radius: 6px;
  margin-left: 12px;
  background-color: #f8f8f8;
  cursor: pointer;
}
.box12_top_button_button1:nth-child(1) {
  margin-left: 0;
}
.box12_top_button_button2 {
  background-color: #fcad2a;
  color: #fff;
}
.box12_top_tip {
  font-size: 14px;
  color: #333333;
}
.box12_top_legend_box {
  display: flex;
  margin-top: 20px;
}
.box12_top_legend_box_option1 {
  display: flex;
  align-content: center;
  font-size: 14px;
  line-height: 15px;
  color: #333333;
  margin-left: 15px;
  cursor: pointer;
}
.box12_top_legend_box_option1:nth-child(1) {
  margin-left: 0;
}
.box12_top_legend_box_option1_colordiv {
  background-color: #539cff;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box12_top_legend_box_option2_colordiv {
  background-color: #fcad2a;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}

.box13_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}
.box13_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  /* opacity: 0.06; */
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
}
.box13_top_legend_box {
  display: flex;
  margin-top: 20px;
}
.box13_top_legend_box_option1 {
  display: flex;
  align-content: center;
  font-size: 14px;
  line-height: 15px;
  color: #333333;
  margin-left: 15px;
  cursor: pointer;
}
.box13_top_legend_box_option1:nth-child(1) {
  margin-left: 0;
}
.box13_top_legend_box_option1_colordiv {
  background-color: #fd4c4c;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box13_top_legend_box_option2_colordiv {
  background-color: #fcad2a;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box13_top_legend_box_option3_colordiv {
  background-color: rgba(252, 173, 42, 1);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box13_top_legend_box_option4_colordiv {
  background-color: rgba(252, 173, 42, 0.8);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box13_top_legend_box_option5_colordiv {
  background-color: rgba(252, 173, 42, 0.6);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box13_top_legend_box_option6_colordiv {
  background-color: #539cff;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box13_top_tip1 {
  height: 70px;
  line-height: 70px;
  font-size: 14px;
  color: #333333;
  padding-left: 10px;
}
.box13_top_tip2 {
  font-size: 14px;
  color: #333333;
}
.i1 {
  font-style: normal;
  color: #fd4c4c;
}
.box13_technological_process {
  margin-top: 30px;
  /* float: right; */
  display: flex;
  width: 1405px;
  min-width: 1405px;
  justify-content: space-between;
}
.box13_technological_process_box1 {
  width: 292px;
  height: 90px;
  background-color: #ffffff;
  box-shadow: 0px 1px 11px 1px rgba(220, 220, 220, 0.4);
  border-radius: 10px;
  padding: 21px 19px 16px 17px;
}
.box13_technological_process_box1_title {
  font-size: 14px;
  color: #333333;
}
.box13_technological_process_box1_bootom_option1_jindu {
  display: flex;
  align-content: center;
  margin-top: 10px;
}
.box13_technological_process_box1_bootom_option1_jindu_jindu1 {
  width: 28px;
  height: 0;
  border-bottom: 1px solid #bfbfbf;
  margin-top: 7px;
}
.box13_technological_process_box1_bootom_option1_jindu_jindu12 {
  border-color: #fcad2a;
}
.box13_technological_process_box1_bootom_option1_jindu_jindu2 {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 1px solid #bfbfbf;
}
.box13_technological_process_box1_bootom_option1_jindu_jindu22 {
  border-color: #fcad2a;
}
.box13_technological_process_box1_bootom_option1_jindu_jindu3 {
  width: 28px;
  height: 0;
  border-bottom: 1px solid #bfbfbf;
  margin-top: 7px;
}
.box13_technological_process_box1_bootom_option1_jindu_jindu32 {
  border-color: #fcad2a;
}
.box13_technological_process_box1_bootom_option1_text1 {
  color: #333;
  font-size: 14px;
  margin-top: 5px;
}
.box13_technological_process_box1_bootom_option1_text2 {
  font-size: 12px;
  color: #999999;
  margin-top: 5px;
}
.box13_technological_process_box1_bootom_option1 {
  width: 73px;
  text-align: center;
}
.box13_technological_process_box1_bootom {
  display: flex;
}

.box13_fyq {
  text-align: right;
  margin-top: 17px;
  float: right;
}
.box13_fyq
  /deep/.el-pagination.is-background
  .el-pager
  li:not(.disabled).active {
  background-color: #fcad2a;
  /* color: #fff; */
}
.box13_top_tip3 {
  height: 70px;
  line-height: 70px;
  font-size: 14px;
  color: #333333;
  padding-left: 10px;
}
.box13_top_tip4 {
  font-size: 14px;
  color: #333333;
}

.box14_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}
.box14_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  /* opacity: 0.06; */
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
}
.box14_top_legend_box {
  display: flex;
  margin-top: 20px;
}
.box14_top_legend_box_option1 {
  display: flex;
  align-content: center;
  font-size: 14px;
  line-height: 15px;
  color: #333333;
  margin-left: 15px;
  cursor: pointer;
}
.box14_top_legend_box_option1:nth-child(1) {
  margin-left: 0;
}
.box14_top_legend_box_option1_colordiv {
  background-color: #fcad2a;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box14_top_legend_box_option2_colordiv {
  background-color: #539cff;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box14_top_legend_box_option3_colordiv {
  background-color: #fd4c4c;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}

.box14_top_tip1 {
  height: 70px;
  line-height: 70px;
  font-size: 14px;
  color: #333333;
  padding-left: 10px;
}
.box14_top_button {
  display: flex;
  align-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.box14_top_button_button1 {
  padding: 6px 10px;
  text-align: center;
  font-size: 14px;
  color: #333333;
  border-radius: 6px;
  margin-left: 12px;
  background-color: #f8f8f8;
  cursor: pointer;
}
.box14_top_button_button1:nth-child(1) {
  margin-left: 0;
}
.box14_top_button_button2 {
  background-color: #fcad2a;
  color: #fff;
}

.box15_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}
.box15_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  /* opacity: 0.06; */
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
}
.box15_top_button {
  display: flex;
  align-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.box15_top_button_button1 {
  padding: 6px 10px;
  text-align: center;
  font-size: 14px;
  color: #333333;
  border-radius: 6px;
  margin-left: 12px;
  background-color: #f8f8f8;
  cursor: pointer;
}
.box15_top_button_button1:nth-child(1) {
  margin-left: 0;
}
.box15_top_button_button2 {
  background-color: #fcad2a;
  color: #fff;
}

.box16_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}
.box16_top_title_text1 {
}
.box16_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  /* opacity: 0.06; */
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
}
.box16_top_button {
  display: flex;
  align-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.box16_top_button_button1 {
  padding: 6px 10px;
  text-align: center;
  font-size: 14px;
  color: #333333;
  border-radius: 6px;
  margin-left: 12px;
  background-color: #f8f8f8;
  cursor: pointer;
}
.box16_top_button_button1:nth-child(1) {
  margin-left: 0;
}
.box16_top_button_button2 {
  background-color: #fcad2a;
  color: #fff;
}
.box16_top_tip {
  font-size: 14px;
  color: #333333;
}
.box16_top_legend_box {
  display: flex;
  margin-top: 20px;
}
.box16_top_legend_box_option1 {
  display: flex;
  align-content: center;
  font-size: 14px;
  line-height: 15px;
  color: #333333;
  margin-left: 15px;
  cursor: pointer;
}
.box16_top_legend_box_option1:nth-child(1) {
  margin-left: 0;
}
.box16_top_legend_box_option1_colordiv {
  background-color: #539cff;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box16_top_legend_box_option2_colordiv {
  background-color: #fcad2a;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}

.box17_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}
.box17_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
}
.box17_top_tip1 {
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  color: #333333;
  padding-left: 10px;
}

.box18_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}
.box18_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
}
.box18_top_tip1 {
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  color: #333333;
  padding-left: 10px;
}
.box18_top_legend_box {
  display: flex;
  /* margin-top: 20px; */
}
.box18_top_legend_box_option1 {
  display: flex;
  align-content: center;
  font-size: 14px;
  line-height: 15px;
  color: #333333;
  margin-left: 15px;
  cursor: pointer;
}
.box18_top_legend_box_option1:nth-child(1) {
  margin-left: 0;
}
.box18_top_legend_box_option1_colordiv {
  background-color: #fd4c4c;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box18_top_legend_box_option2_colordiv {
  background-color: #fcad2a;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box18_top_legend_box_option3_colordiv {
  background-color: #3cbb73;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}

.box19_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}
.box19_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
}
.box19_bottom {
  margin-top: 20px;
}

.box20_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}

.box20_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  /* opacity: 0.06; */
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
}

.box20_top_button {
  display: flex;
  align-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.box20_top_button_button1 {
  padding: 6px 10px;
  text-align: center;
  font-size: 14px;
  color: #333333;
  border-radius: 6px;
  margin-left: 12px;
  background-color: #f8f8f8;
  cursor: pointer;
}
.box20_top_button_button1:nth-child(1) {
  margin-left: 0;
}
.box20_top_button_button2 {
  background-color: #fcad2a;
  color: #fff;
}
.box20_top_legend_box {
  display: flex;
  /* margin-top: 20px; */
}
.box20_top_legend_box_option1 {
  display: flex;
  align-content: center;
  font-size: 14px;
  line-height: 15px;
  color: #333333;
  margin-left: 15px;
  cursor: pointer;
}
.box20_top_legend_box_option1:nth-child(1) {
  margin-left: 0;
}
.box20_top_legend_box_option1_colordiv {
  background-color: #fcad2a;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box20_top_legend_box_option2_colordiv {
  background-color: #539cff;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}

.box21_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}

.box21_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  /* opacity: 0.06; */
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
}

.box21_top_legend_box {
  display: flex;
  margin-top: 20px;
}
.box21_top_legend_box_option1 {
  display: flex;
  align-content: center;
  font-size: 14px;
  line-height: 15px;
  color: #333333;
  margin-left: 15px;
  cursor: pointer;
}
.box21_top_legend_box_option1:nth-child(1) {
  margin-left: 0;
}
.box21_top_legend_box_option1_colordiv {
  background-color: #fcad2a;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box21_top_legend_box_option2_colordiv {
  background-color: #539cff;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}

.box22_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}

.box22_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  /* opacity: 0.06; */
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
}

.box22_top_legend_box {
  display: flex;
  margin-top: 20px;
}
.box22_top_legend_box_option1 {
  display: flex;
  align-content: center;
  font-size: 14px;
  line-height: 15px;
  color: #333333;
  margin-left: 15px;
  cursor: pointer;
}
.box22_top_legend_box_option1:nth-child(1) {
  margin-left: 0;
}
.box22_top_legend_box_option1_colordiv {
  background-color: #fcad2a;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box22_top_legend_box_option2_colordiv {
  background-color: #539cff;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}

.box23_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}
.box23_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
}
.box23_bottom {
  margin-top: 20px;
}

.box24_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}
.box24_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
}
.box24_bottom {
  margin-top: 20px;
}

.box25_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}
.box25_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
}
.tuceng {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999999;
}
.box3_content {
  margin-bottom: 35px;
}
.box3_content_options1 {
  display: flex;
}
.box3_content_options1_text1 {
  width: 72px;
  height: 30px;
  background-color: rgba(253, 76, 76, 0.06);
  border-radius: 6px;
  font-size: 16px;
  line-height: 30px;
  color: #fd4c4c;
  text-align: center;
}
.box3_content_options1_text2 {
  font-size: 16px;
  line-height: 30px;
  color: #333333;
  margin-left: 12px;
}
.box4_content {
  margin-bottom: 35px;
}

.box4_content_options1 {
  display: flex;
}
.box4_content_options1_text1 {
  width: 72px;
  height: 30px;
  background-color: rgba(83, 156, 255, 0.06);
  border-radius: 6px;
  font-size: 16px;
  line-height: 30px;
  color: #539cff;
  text-align: center;
}
.box4_content_options1_text2 {
  font-size: 16px;
  line-height: 30px;
  color: #333333;
  margin-left: 12px;
}
.margin_top18 {
  margin-top: 18px;
}
.box15_bottom_top_title {
  width: 65px;
  height: 16px;
  font-size: 16px;
  color: #333333;
  position: relative;
  z-index: 5;
}
.box15_bottom_top_title::after {
  content: "";
  display: block;
  width: 60px;
  height: 4px;
  background-image: linear-gradient(135deg, #f8c54a 0%, #fcad2a 100%),
    linear-gradient(#fd4c4c, #fd4c4c);
  background-blend-mode: normal, normal;
  box-shadow: 0px 4px 16px 2px rgba(252, 173, 42, 0.13);
  border-radius: 1px;
  overflow: hidden;
  margin: 0 auto;
  position: absolute;
  bottom: -4px;
  left: calc(50% - 30px);
  z-index: -4;
}
.box15_bottom_top {
  display: flex;
}
.box15_bottom_top_text img {
  width: 10px;
  height: 13px;
  margin-right: 3px;
}
.colorGreen{
  color: #3cbb73;
}
.colorRed{
  color: #fd4c4c;
}
</style>